import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import logout from './images/logout.png';
import logo from './images/logo_white.png';
import welcomeuser from './images/hamburger_icon.png';
import replacement from './images/replacement.png';
import posterReplacement from './images/poster_replacement_old.png';
import premium from './images/premium.png';
import liveBtn from './images/live.png';
import './App.css';
import { Auth } from 'aws-amplify';
import Amplify, { Analytics, Storage, API, graphqlOperation } from 'aws-amplify';
import * as queries from './graphql/queries';
import * as subscriptions from './graphql/subscriptions';
import Slider from "react-slick";
import * as constant from './Constant';
import * as version from './Version';

class Landing extends React.Component {

	constructor(props) {
		super(props);
		var self = this;
		this.state = {
			
			hiUser:'',
			userFirstName: '',
			bgColor:'',
			activeTabColor: '',
			inactiveTabColor: '',
			textColor: '',
			welcomeMsg:'',
			imageBaseURI: '',
			videoBaseURI: '',
			liveVideoBaseURI: '',
			ratingEnable: '',
			contentStats: '',
			durationEnable: '',
			overlayBackground: '',
			overlayText: '',
			overlayTextEnabled: '',
			imagetypeforslider: '',
            imagetypeforlist: '',
            bypassdetails: '',
            showCompare: false,

            searchData: [],
            noSearchData: 'false',
			activeInfo: '0'
		};
		this.onInit();
	}

	onInit() {

		var userName = localStorage.getItem('userName');
		var userProfileValue = localStorage.getItem('userProfile');
		var userNewMasterId = localStorage.getItem('userNewMasterId');
		var showWelcomePopup = localStorage.getItem('showWelcomePopup');
		var baseUrl = localStorage.getItem("imageBaseURI");


		this.isHEVCSupport = localStorage.getItem("isHEVCSupport");
		this.isAV1Support = localStorage.getItem("isAV1Support");

		//Auth.currentSession();
		if(userName) {

			if (userNewMasterId == constant.Master_id) {
				API.graphql(graphqlOperation(queries.getPlarformSchemaChangeId, { id: constant.Master_id }))
         		.then(data => this.displayChangeIddata(data))
          		.catch(err => this.displayChangeIderror(err));
	        } else {
	        	API.graphql(graphqlOperation(queries.getPlarformSchemaChangeId, { id: userNewMasterId }))
         		.then(data => this.displayChangeIddata(data))
          		.catch(err => this.displayChangeIderror(err));
	        }

			let cookieValue = document.cookie.split(';').reduce((ac, str) => Object.assign(ac, {[str.split('=')[0].trim()]: str.split('=')[1]}), {});

		    if( (cookieValue.welcomePopup == undefined || cookieValue.welcomePopup == 0) && (showWelcomePopup == '0') ) {
		      window.setTimeout( function(){
		        window.$('#welcomePopupModal').modal('show');
		        localStorage.setItem('showWelcomePopup', '1');
		      }, 500 );
		    }

		}


		if(userName) {

			if ( userNewMasterId == constant.Master_id ) {
				const subscription = API.graphql(
	            graphqlOperation(subscriptions.onUpdatePlarformSchema, { id : constant.Master_id})
		        ).subscribe({
		            next: (todoData) => this.subscribevalue(todoData) 
		        });
			} else {
				const subscription1 = API.graphql(
				graphqlOperation(subscriptions.onUpdatePlarformSchema, { id : constant.Master_id})
				).subscribe({
					next: (todoData) => this.subscribevalue(todoData) 
				});

				const subscription = API.graphql(
	            graphqlOperation(subscriptions.onUpdatePlarformSchema, { id : userNewMasterId})
		        ).subscribe({
		            next: (todoData) => this.subscribevalue(todoData) 
		        });
			}
			

			localStorage.setItem('isAuthenticated', 'true');
			localStorage.setItem('fromRoute', 'mtab');

			} else {
				this.props.history.push('/')
				window.location.reload();
			}
	}


		componentDidMount() {
			this.setState({
		  		hiUser: localStorage.getItem("userName"),
		  		userFirstName: localStorage.getItem("userFirstName"),
		  		bgColor: localStorage.getItem("bgColor"),
				activeTabColor: localStorage.getItem("activeTabColor"),
				inactiveTabColor: localStorage.getItem("inactiveTabColor"),
				contentStatsText: localStorage.getItem("contentStatsText"),
		  		textColor: localStorage.getItem("textColor"),
		  		welcomeMsg: localStorage.getItem("welcomeMsg"),
		  		imageBaseURI: localStorage.getItem("imageBaseURI"),
		  		videoBaseURI: localStorage.getItem("videoBaseURI"),
				liveVideoBaseURI: localStorage.getItem("liveVideoBaseURI"),
		  		ratingEnable: localStorage.getItem("ratingEnable"),
		  		contentStats: localStorage.getItem("contentStats"),
		  		durationEnable: localStorage.getItem("durationEnable"),
		  		overlayBackground: localStorage.getItem("overlayBackground"),
		  		overlayText: localStorage.getItem("overlayText"),
		  		overlayTextEnabled: localStorage.getItem("overlayTextEnabled"),
		  		imagetypeforslider: localStorage.getItem("imagetypeforslider"),
            	imagetypeforlist: localStorage.getItem("imagetypeforlist"),
            	showPromoContent: localStorage.getItem("showPromoContent"),
				activeInfo: parseInt(localStorage.getItem('activeInfo') || '0', 10)
			});

			const activeInfo = localStorage.getItem('activeInfo');

			if (activeInfo !== null) {
				this.setState({
					activeInfo: parseInt(activeInfo, 10)
				});
			}

			var verticalContent = localStorage.getItem('verticalContent');

	  		if(verticalContent == '0') {
	  			this.setState({
		            showPromoContent : '0'
		        });
	  		}
		}

		displayChangeIderror(err) {
			console.log(err);
			var fromPlayerRoute = localStorage.getItem('routefromplayer');
			var fromContentDetailRoute = localStorage.getItem('routefromContentDetail');
			var fromLaunchPlayerRoute = localStorage.getItem('routefromLaunchPlayer');
			var fromComparePlayerRoute = localStorage.getItem('routefromComparePlayer');
			if(err.errors && err.errors[0].message == 'Network Error') {
				if (fromPlayerRoute == 'fromPlayer' || fromContentDetailRoute == 'fromContentDetail' || fromLaunchPlayerRoute == 'fromLaunchPlayer' || fromComparePlayerRoute == 'fromComparePlayer' ) {
					localStorage.setItem('routefromplayer', '');
					localStorage.setItem('routefromContentDetail', '');
					localStorage.setItem('routefromLaunchPlayer', '');
					localStorage.setItem('routefromComparePlayer', '');
				} else {
					//alert('There appears to be a problem with your internet connection. Please check connections and retry.');
				}
			} else {
				localStorage.clear();
	    		this.props.history.push('/')
			}
		}

		displayChangeIddata(data) {
			var userProfileValue = localStorage.getItem('userProfile');
			var userNewMasterId = localStorage.getItem('userNewMasterId');
			var changeIdTrigger = localStorage.getItem('changeIdTrigger');
			if(changeIdTrigger != data.data.getPlarformSchema.Trigger) {
				localStorage.setItem('changeIdTrigger',data.data.getPlarformSchema.Trigger);
				if (userNewMasterId == constant.Master_id) {
					API.graphql(graphqlOperation(queries.getPlarformSchema, { id: constant.Master_id }))
		         	.then(data => this.displaydata(data))
		          	.catch(err => this.displayerror(err));
		        } else {
		        	API.graphql(graphqlOperation(queries.getPlarformSchema, { id: userNewMasterId }))
		         	.then(data => this.noVnovaUserData(data))
		          	.catch(err => this.displayerror(err));
		        }
			}
		}

		subscribevalue(todoData) {
			var userProfileValue = localStorage.getItem('userProfile');
			var userNewMasterId = localStorage.getItem('userNewMasterId');
			if (userNewMasterId == constant.Master_id) {
				API.graphql(graphqlOperation(queries.getPlarformSchema, { id: constant.Master_id }))
	         	.then(data => this.displaydata(data))
	          	.catch(err => this.displayerror(err));
	        } else {
	        	API.graphql(graphqlOperation(queries.getPlarformSchema, { id: userNewMasterId }))
	         	.then(data => this.noVnovaUserData(data))
	          	.catch(err => this.displayerror(err));
	        }
			
      	}

	    displayerror(err) {
	    	console.log(err);
			var fromPlayerRoute = localStorage.getItem('routefromplayer');
			var fromContentDetailRoute = localStorage.getItem('routefromContentDetail');
			var fromLaunchPlayerRoute = localStorage.getItem('routefromLaunchPlayer');
			var fromComparePlayerRoute = localStorage.getItem('routefromComparePlayer');
			if(err.errors && err.errors[0].message == 'Network Error') {
				if (fromPlayerRoute == 'fromPlayer' || fromContentDetailRoute == 'fromContentDetail' || fromLaunchPlayerRoute == 'fromLaunchPlayer' || fromComparePlayerRoute == 'fromComparePlayer' ) {
					localStorage.setItem('routefromplayer', '');
					localStorage.setItem('routefromContentDetail', '');
					localStorage.setItem('routefromLaunchPlayer', '');
					localStorage.setItem('routefromComparePlayer', '');
				} else {
					//alert('There appears to be a problem with your internet connection. Please check connections and retry.');
				}
			} else {
				localStorage.clear();
	    		this.props.history.push('/')
			}
	    }


	  noVnovaUserData(data) {
	  	this.listOfAppConfiguration = JSON.parse(data.data.getPlarformSchema.AppConfiguration);
	    this.listOfVodAssets = JSON.parse(data.data.getPlarformSchema.VodNew);
	    this.listOfLive = JSON.parse(data.data.getPlarformSchema.Live);

		localStorage.setItem('listOfDemoCntLive', JSON.stringify(this.listOfLive));

	    localStorage.setItem('changeIdTrigger',data.data.getPlarformSchema.Trigger);
	    var userProfile = localStorage.getItem('userProfile');
      	var userProfileName = localStorage.getItem('userProfileName');
      	var userId = localStorage.getItem('userId');

	    /*To show the demo for the external users too*/
	    if(this.listOfAppConfiguration.ShowDemoContents && this.listOfAppConfiguration.ShowDemoContents == '1') {

	      API.graphql(graphqlOperation(queries.getPlarformSchema, { id: constant.Master_id })).then(data => 
	        {
	          this.listOfDemoVodAssets = JSON.parse(data.data.getPlarformSchema.VodNew);
	          this.listOfDemoLive = JSON.parse(data.data.getPlarformSchema.Live);
	          this.listOfDemoContentCategoriesProd = JSON.parse(data.data.getPlarformSchema.ContentCategories);
	          this.listOfDemoPromotedContent = JSON.parse(data.data.getPlarformSchema.PromotedContentnew);

	          localStorage.setItem('listOfLive', JSON.stringify(this.listOfDemoLive));
	          localStorage.setItem('listOfPromotedContent', JSON.stringify(this.listOfDemoPromotedContent));
	          let promotedContentArray = [];
	          if(this.listOfDemoPromotedContent) {
	            for( var i=0; i<this.listOfDemoPromotedContent.length; i++) {
	              if( (this.listOfDemoPromotedContent[i].Typeid && this.listOfDemoPromotedContent[i].Typeid == '1') || (this.listOfDemoPromotedContent[i].TypeID && this.listOfDemoPromotedContent[i].TypeID == '1') || (this.listOfDemoPromotedContent[i].TypeId && this.listOfDemoPromotedContent[i].TypeId == '1') || (this.listOfDemoPromotedContent[i].TypeiD && this.listOfDemoPromotedContent[i].TypeiD == '1') ) {
	                promotedContentArray.push(this.listOfDemoPromotedContent[i]);
	              }
	              if( ( (this.listOfDemoPromotedContent[i].Typeid && this.listOfDemoPromotedContent[i].Typeid == '0') || (this.listOfDemoPromotedContent[i].TypeID && this.listOfDemoPromotedContent[i].TypeID == '0') || (this.listOfDemoPromotedContent[i].TypeId && this.listOfDemoPromotedContent[i].TypeId == '0') || (this.listOfDemoPromotedContent[i].TypeiD && this.listOfDemoPromotedContent[i].TypeiD == '0') ) 
                  && ( (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID] && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].IsEnabled && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].IsEnabled == '1' && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].IsPrivate != '1' || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].IsPrivate == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].Platform == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].Platform == undefined || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentID].Platform.includes("Website"))) ) 
                  || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid] && this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].IsEnabled && this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].IsEnabled == '1' && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].IsPrivate != '1' || this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].IsPrivate == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].Platform == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].Platform == undefined || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].Contentid].Platform.includes("Website"))) ) 
                  || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId] && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].IsEnabled && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].IsEnabled == '1' && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].IsPrivate != '1' || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].IsPrivate == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].Platform == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].Platform == undefined || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentId].Platform.includes("Website"))) ) 
                  || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD] && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].IsEnabled && this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].IsEnabled == '1' && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].IsPrivate != '1' || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].IsPrivate == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].Platform == null || this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].Platform == undefined || (this.listOfVodAssets[this.listOfDemoPromotedContent[i].ContentiD].Platform.includes("Website"))) ) ) ) {
	                promotedContentArray.push(this.listOfDemoVodAssets[this.listOfDemoPromotedContent[i].Contentid] || this.listOfDemoVodAssets[this.listOfDemoPromotedContent[i].ContentID] || this.listOfDemoVodAssets[this.listOfDemoPromotedContent[i].ContentId] || this.listOfDemoVodAssets[this.listOfDemoPromotedContent[i].ContentiD]);
	              }
	              localStorage.setItem('promotedContentArray', JSON.stringify(promotedContentArray));
	            }
	          }// end of promoted contents

	          let newContentCategory = [];
	    
	          for(var i=0; i<Object.keys(this.listOfDemoContentCategoriesProd).length; i++) {
	            /*For Content Category Names*/
	            if(this.listOfDemoContentCategoriesProd[Object.keys(this.listOfDemoContentCategoriesProd)[i]].Status == '1') {
	              newContentCategory.push( {
	                title: this.listOfDemoContentCategoriesProd[Object.keys(this.listOfDemoContentCategoriesProd)[i]].Title[0] + ' Demo',
	                serial: this.listOfDemoContentCategoriesProd[Object.keys(this.listOfDemoContentCategoriesProd)[i]].Serial,
	                Bouquet: this.listOfDemoContentCategoriesProd[Object.keys(this.listOfDemoContentCategoriesProd)[i]].Bouquet,
	                Status: this.listOfDemoContentCategoriesProd[Object.keys(this.listOfDemoContentCategoriesProd)[i]].Status,
	                vertical: '1'
	              })
	              // sort by serial
	              newContentCategory.sort(function (a, b) {
	                return a.serial - b.serial;
	              });
	            }
	          }//end of Content Category Names


	          let finalLists = [];
	          for(var i=0; i<newContentCategory.length; i++) {
	            /*For Content Category Bouquet*/
	            if(newContentCategory[i].Status == '1') {
	              let listBouquets = newContentCategory[i].Bouquet
	              let perfinalList = [];
	              if(listBouquets) {
	                listBouquets.forEach((listBouquet)=>{
	                  if(listBouquet.Name != null && listBouquet.ContentIdwithType !== null) {
	                  let list = {Name :listBouquet.Name[0], Contents : [], contentType : []};
	                  listBouquet.ContentIdwithType.forEach((Contents)=> {
	                    if(Contents.Type == 'VOD') {
	                        if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {

								if( (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfDemoVodAssets[Contents.ContentId].Codec && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '4') && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentId].Platform == null || this.listOfDemoVodAssets[Contents.ContentId].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentId].Platform.includes("Website")))) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfDemoVodAssets[Contents.ContentID].Codec && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '4') && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentID].Platform == null || this.listOfDemoVodAssets[Contents.ContentID].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentID].Platform.includes("Website"))) ) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfDemoVodAssets[Contents.Contentid].Codec && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '3') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '4') && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == null || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfDemoVodAssets[Contents.Contentid].Platform == null || this.listOfDemoVodAssets[Contents.Contentid].Platform == undefined || (this.listOfDemoVodAssets[Contents.Contentid].Platform.includes("Website")))) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfDemoVodAssets[Contents.ContentiD].Codec && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '4') && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentiD].Platform == null || this.listOfDemoVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
								  
								  list.Contents.push(this.listOfDemoVodAssets[Contents.ContentId] || this.listOfDemoVodAssets[Contents.ContentID] || this.listOfDemoVodAssets[Contents.Contentid] || this.listOfDemoVodAssets[Contents.ContentiD])
								  list.contentType.push({
									type: 'VOD',
									contentId: Contents.ContentID
								  })
				  
								  if(this.listOfAppConfiguration.Contentorder == '1') {
									list.Contents.sort(function(a, b) {
									  return a.Title.localeCompare(b.Title);
									});
								  }
								}
		
							  } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {
		
								if( (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfDemoVodAssets[Contents.ContentId].Codec && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '4') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentId].Platform == null || this.listOfDemoVodAssets[Contents.ContentId].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentId].Platform.includes("Website")))) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfDemoVodAssets[Contents.ContentID].Codec && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '4') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentID].Platform == null || this.listOfDemoVodAssets[Contents.ContentID].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentID].Platform.includes("Website"))) ) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfDemoVodAssets[Contents.Contentid].Codec && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '3') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '4') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '5') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '9') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '6') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '10') && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == null || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfDemoVodAssets[Contents.Contentid].Platform == null || this.listOfDemoVodAssets[Contents.Contentid].Platform == undefined || (this.listOfDemoVodAssets[Contents.Contentid].Platform.includes("Website")))) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfDemoVodAssets[Contents.ContentiD].Codec && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '3') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '4') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentiD].Platform == null || this.listOfDemoVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
								  
								  list.Contents.push(this.listOfDemoVodAssets[Contents.ContentId] || this.listOfDemoVodAssets[Contents.ContentID] || this.listOfDemoVodAssets[Contents.Contentid] || this.listOfDemoVodAssets[Contents.ContentiD])
								  list.contentType.push({
									type: 'VOD',
									contentId: Contents.ContentID
								  })
				  
								  if(this.listOfAppConfiguration.Contentorder == '1') {
									list.Contents.sort(function(a, b) {
									  return a.Title.localeCompare(b.Title);
									});
								  }
								}
		
							  } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {
		
								if( (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfDemoVodAssets[Contents.ContentId].Codec && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentId].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentId].Platform == null || this.listOfDemoVodAssets[Contents.ContentId].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentId].Platform.includes("Website")))) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfDemoVodAssets[Contents.ContentID].Codec && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentID].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentID].Platform == null || this.listOfDemoVodAssets[Contents.ContentID].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentID].Platform.includes("Website"))) ) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfDemoVodAssets[Contents.Contentid].Codec && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '5') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '9') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '6') && (this.listOfDemoVodAssets[Contents.Contentid].Codec != '10') && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == null || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfDemoVodAssets[Contents.Contentid].Platform == null || this.listOfDemoVodAssets[Contents.Contentid].Platform == undefined || (this.listOfDemoVodAssets[Contents.Contentid].Platform.includes("Website")))) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfDemoVodAssets[Contents.ContentiD].Codec && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '5') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '9') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '6') && (this.listOfDemoVodAssets[Contents.ContentiD].Codec != '10') && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentiD].Platform == null || this.listOfDemoVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
								  
								  list.Contents.push(this.listOfDemoVodAssets[Contents.ContentId] || this.listOfDemoVodAssets[Contents.ContentID] || this.listOfDemoVodAssets[Contents.Contentid] || this.listOfDemoVodAssets[Contents.ContentiD])
								  list.contentType.push({
									type: 'VOD',
									contentId: Contents.ContentID
								  })
				  
								  if(this.listOfAppConfiguration.Contentorder == '1') {
									list.Contents.sort(function(a, b) {
									  return a.Title.localeCompare(b.Title);
									});
								  }
								}
		
							  } else {
		
								if( (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled && this.listOfDemoVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentId].Platform == null || this.listOfDemoVodAssets[Contents.ContentId].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentId].Platform.includes("Website")))) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled && this.listOfDemoVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentID].Platform == null || this.listOfDemoVodAssets[Contents.ContentID].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentID].Platform.includes("Website"))) ) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled && this.listOfDemoVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == null || this.listOfDemoVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfDemoVodAssets[Contents.Contentid].Platform == null || this.listOfDemoVodAssets[Contents.Contentid].Platform == undefined || (this.listOfDemoVodAssets[Contents.Contentid].Platform.includes("Website")))) 
								|| (this.listOfDemoVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled && this.listOfDemoVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfDemoVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfDemoVodAssets[Contents.ContentiD].Platform == null || this.listOfDemoVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfDemoVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
								  
								  list.Contents.push(this.listOfDemoVodAssets[Contents.ContentId] || this.listOfDemoVodAssets[Contents.ContentID] || this.listOfDemoVodAssets[Contents.Contentid] || this.listOfDemoVodAssets[Contents.ContentiD])
								  list.contentType.push({
									type: 'VOD',
									contentId: Contents.ContentID
								  })
				  
								  if(this.listOfAppConfiguration.Contentorder == '1') {
									list.Contents.sort(function(a, b) {
									  return a.Title.localeCompare(b.Title);
									});
								  }
								}
		
							  }
	                      } else {
	                          if( (this.listOfDemoLive.hasOwnProperty(Contents.ContentId) && this.listOfDemoLive[Contents.ContentId].IsEnabled && this.listOfDemoLive[Contents.ContentId].IsEnabled == '1' && (this.listOfDemoLive[Contents.ContentId].IsPrivate != '1' || this.listOfDemoLive[Contents.ContentId].IsPrivate == null || this.listOfDemoLive[Contents.ContentId].IsPrivate == undefined) && (this.listOfDemoLive[Contents.ContentId].AppPlatforms == null || this.listOfDemoLive[Contents.ContentId].AppPlatforms == undefined || (this.listOfDemoLive[Contents.ContentId].AppPlatforms.includes("Website")))) || (this.listOfDemoLive.hasOwnProperty(Contents.ContentID) && this.listOfDemoLive[Contents.ContentID].IsEnabled && this.listOfDemoLive[Contents.ContentID].IsEnabled == '1' && (this.listOfDemoLive[Contents.ContentID].IsPrivate != '1' || this.listOfDemoLive[Contents.ContentID].IsPrivate == null || this.listOfDemoLive[Contents.ContentID].IsPrivate == undefined) && (this.listOfDemoLive[Contents.ContentID].AppPlatforms == null || this.listOfDemoLive[Contents.ContentID].AppPlatforms == undefined || (this.listOfDemoLive[Contents.ContentID].AppPlatforms.includes("Website"))) ) || (this.listOfDemoLive.hasOwnProperty(Contents.Contentid) && this.listOfDemoLive[Contents.Contentid].IsEnabled && this.listOfDemoLive[Contents.Contentid].IsEnabled == '1' && (this.listOfDemoLive[Contents.Contentid].IsPrivate != '1' || this.listOfDemoLive[Contents.Contentid].IsPrivate == null || this.listOfDemoLive[Contents.Contentid].IsPrivate == undefined) &&(this.listOfDemoLive[Contents.Contentid].AppPlatforms == null || this.listOfDemoLive[Contents.Contentid].AppPlatforms == undefined || (this.listOfDemoLive[Contents.Contentid].AppPlatforms.includes("Website")))) || (this.listOfDemoLive.hasOwnProperty(Contents.ContentiD) && this.listOfDemoLive[Contents.ContentiD].IsEnabled && this.listOfDemoLive[Contents.ContentiD].IsEnabled == '1' && (this.listOfDemoLive[Contents.ContentiD].IsPrivate != '1' || this.listOfDemoLive[Contents.ContentiD].IsPrivate == null || this.listOfDemoLive[Contents.ContentiD].IsPrivate == undefined) && (this.listOfDemoLive[Contents.ContentiD].AppPlatforms == null || this.listOfDemoLive[Contents.ContentiD].AppPlatforms == undefined || (this.listOfDemoLive[Contents.ContentiD].AppPlatforms.includes("Website")))) ){
	                            list.Contents.push(this.listOfDemoLive[Contents.ContentId] || this.listOfDemoLive[Contents.ContentID] || this.listOfDemoLive[Contents.Contentid] || this.listOfDemoLive[Contents.ContentiD] )
								list.contentType.push({
									type: Contents.Type,
									contentId: Contents.ContentID
								})

								if(this.listOfAppConfiguration.Contentorder == '1') {
		                            list.Contents.sort(function(a, b) {
		                              return a.Title[0].localeCompare(b.Title[0]);
		                            });
		                        }
	                          }
	                      }
	                  });

	                  if(list.Contents.length > '0') {
	                    perfinalList.push(list)
	                  }
	                        
	                  } 
	                });
	              }
	              finalLists.push(perfinalList);
	            }
	          }// end of the finalLists for loop

	          if(this.listOfVodAssets) {
	            let perfinalList = [];
	            let list = {Name :'', Contents : []};

				for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
					if(this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate != '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == '1' ) {
					  list.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
						//sort by alphabet
						if(this.listOfAppConfiguration.Contentorder == '1') {
						  list.Contents.sort(function(a, b) {
							return a.Title[0].localeCompare(b.Title[0]);
						  });
						} else {
						  // sort by JobID
						  list.Contents.sort(function (a, b) {
							return b.JobID - a.JobID;
						  });
						}
					}
				}

	            for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
	             
					if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {

						if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
						  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
						  //sort by alphabet
						  if(this.listOfAppConfiguration.Contentorder == '1') {
							list.Contents.sort(function(a, b) {
							  return a.Title.localeCompare(b.Title);
							});
						  } else {
							// sort by JobID
							list.Contents.sort(function (a, b) {
							  return b.JobID - a.JobID;
							});
						  }
						}
		
					  } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {
		
						if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
						  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
						  //sort by alphabet
						  if(this.listOfAppConfiguration.Contentorder == '1') {
							list.Contents.sort(function(a, b) {
							  return a.Title.localeCompare(b.Title);
							});
						  } else {
							// sort by JobID
							list.Contents.sort(function (a, b) {
							  return b.JobID - a.JobID;
							});
						  }
						}
		
					  } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {
		
						if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
						  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
						  //sort by alphabet
						  if(this.listOfAppConfiguration.Contentorder == '1') {
							list.Contents.sort(function(a, b) {
							  return a.Title.localeCompare(b.Title);
							});
						  } else {
							// sort by JobID
							list.Contents.sort(function (a, b) {
							  return b.JobID - a.JobID;
							});
						  }
						}
		
					  } else {
						if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
						  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
						  //sort by alphabet
						  if(this.listOfAppConfiguration.Contentorder == '1') {
							list.Contents.sort(function(a, b) {
							  return a.Title.localeCompare(b.Title);
							});
						  } else {
							// sort by JobID
							list.Contents.sort(function (a, b) {
							  return b.JobID - a.JobID;
							});
						  }
						}
					  }
					
	            }
	            newContentCategory.push( {
	              title: 'My VOD',
	              vertical: '0'
	            })

	            if(list.Contents.length > '0') {
	              perfinalList.push(list)
	            }

	            finalLists.push(perfinalList);
	          }//end of external user vod asset parsing

	        if(this.listOfLive) {
	          let perfinalList = [];
	          let list = {Name :'', Contents : []};
	          for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
	            if(this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate != '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == '0' || this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == null) ) {
	              list.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
	              //sort by alphabet
	                if(this.listOfAppConfiguration.Contentorder == '1') {
	                  list.Contents.sort(function(a, b) {
	                    return a.Title[0].localeCompare(b.Title[0]);
	                  });
	                } else {
	                  // sort by JobID
	                  list.Contents.sort(function (a, b) {
	                    return b.JobID - a.JobID;
	                  });
	                }
	            }
	          }
	          newContentCategory.push( {
	            title: 'My LIVE',
	            vertical: '0'
	          })

	          if(list.Contents.length > '0') {
	            perfinalList.push(list)
	          }

	          finalLists.push(perfinalList);
	        }//end of external user live parsing

	        /*Mycontent parsing*/
	        if(userProfile == '21') {
	          let perfinalprivateUserContent = [];
	          let privateUserContent = {Name :'', Contents : []};
	          for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
	            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
	              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
	              //sort by alphabet
	                if(this.listOfAppConfiguration.Contentorder == '1') {
	                  privateUserContent.Contents.sort(function(a, b) {
	                    return a.Title.localeCompare(b.Title);
	                  });
	                } else {
	                  // sort by JobID
	                  privateUserContent.Contents.sort(function (a, b) {
	                    return b.JobID - a.JobID;
	                  });
	                }
	            }
	          }
	          for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
	            if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == userProfileName && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
	              privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
	              //sort by alphabet
	                if(this.listOfAppConfiguration.Contentorder == '1') {
	                  privateUserContent.Contents.sort(function(a, b) {
	                    return a.Title[0].localeCompare(b.Title[0]);
	                  });
	                } else {
	                  // sort by JobID
	                  privateUserContent.Contents.sort(function (a, b) {
	                    return b.JobID - a.JobID;
	                  });
	                }
	            }
	          }
	          newContentCategory.push( {
	            title: 'My Content',
	            vertical: '0'
	          })
	          
	          perfinalprivateUserContent.push(privateUserContent);
	          finalLists.push(perfinalprivateUserContent);
	        } else {
	          let perfinalprivateUserContent = [];
	            let privateUserContent = {Name :'', Contents : []};
	            for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
					if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
	                privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
	                //sort by alphabet
	                if(this.listOfAppConfiguration.Contentorder == '1') {
	                  privateUserContent.Contents.sort(function(a, b) {
	                    return a.Title.localeCompare(b.Title);
	                  });
	                } else {
	                  // sort by JobID
	                  privateUserContent.Contents.sort(function (a, b) {
	                    return b.JobID - a.JobID;
	                  });
	                }
	              }
	            }
	            for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
					if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == userProfileName && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
	                privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
	                //sort by alphabet
	                if(this.listOfAppConfiguration.Contentorder == '1') {
	                  privateUserContent.Contents.sort(function(a, b) {
	                    return a.Title[0].localeCompare(b.Title[0]);
	                  });
	                } else {
	                  // sort by JobID
	                  privateUserContent.Contents.sort(function (a, b) {
	                    return b.JobID - a.JobID;
	                  });
	                }
	              }
	            }
	            if(privateUserContent.Contents.length != '0') {
	              newContentCategory.push( {
	                title: 'My Content',
	                vertical: '0'
	              })
	            }

	            perfinalprivateUserContent.push(privateUserContent);
	            finalLists.push(perfinalprivateUserContent);
	        }//end of Mycontent parsing

	        //localStorage.setItem('promotedContentArray', JSON.stringify(promotedContentArray));

	        localStorage.setItem('newContentCategory', JSON.stringify(newContentCategory));

	        localStorage.setItem('jfinalLists', JSON.stringify(finalLists));

	        localStorage.setItem('bgColor',this.listOfAppConfiguration.Color);
			localStorage.setItem('activeTabColor',this.listOfAppConfiguration.ActiveTab);
      		localStorage.setItem('inactiveTabColor',this.listOfAppConfiguration.InactiveTab);
			localStorage.setItem('contentStatsText',this.listOfAppConfiguration.Contentstats[0]);
	        localStorage.setItem('textColor',this.listOfAppConfiguration.TextColor);
	        localStorage.setItem('welcomeMsg',this.listOfAppConfiguration.WelcomeMessage[0]);
	        localStorage.setItem('contentCategories',this.listOfAppConfiguration.ContentCategories);
	        localStorage.setItem('imageBaseURI',this.listOfAppConfiguration.ImageBaseURI);
	        localStorage.setItem('videoBaseURI',this.listOfAppConfiguration.VideoBaseURI);
			localStorage.setItem('liveVideoBaseURI',this.listOfAppConfiguration.LiveVideoBaseURI);
	        localStorage.setItem('ratingEnable',this.listOfAppConfiguration.Rating);
	        localStorage.setItem('contentStats',this.listOfAppConfiguration.Stats);
	        localStorage.setItem('durationEnable',this.listOfAppConfiguration.ContentDuration);
	        localStorage.setItem('overlayBackground',this.listOfAppConfiguration.OverlayBackground);
	        localStorage.setItem('overlayText',this.listOfAppConfiguration.OverlayText);
	        localStorage.setItem('overlayTextEnabled',this.listOfAppConfiguration.TextEnabled);
	        localStorage.setItem('imagetypeforslider',this.listOfAppConfiguration.Imagetypeforslider);
	        localStorage.setItem('imagetypeforlist',this.listOfAppConfiguration.Imagetypeforlist);
	        localStorage.setItem('imagetypeforposter',this.listOfAppConfiguration.Imagetypeforposter);
	        localStorage.setItem('bypassdetails',this.listOfAppConfiguration.Bypassdetails);
	        localStorage.setItem('myaccountemail',this.listOfAppConfiguration.Myaccountemail[0]);
	        localStorage.setItem('myaccountfirstname',this.listOfAppConfiguration.Myaccountfirstname[0]);
	        localStorage.setItem('myaccountlastname',this.listOfAppConfiguration.Myaccountlastname[0]);
	        localStorage.setItem('myaccountsubscriberid',this.listOfAppConfiguration.Myaccountsubscriberid[0]);
	        localStorage.setItem('showPromoContent', '1');

	        if(window.location.pathname == '/mtab') {
				window.location.reload();
			}
	        
	      })//End of new API call

	    } else {
	      localStorage.setItem('isVNovaUser','0');

	      this.listOfVodAssets = JSON.parse(data.data.getPlarformSchema.VodNew);
	      this.listOfLive = JSON.parse(data.data.getPlarformSchema.Live);
	      this.listOfContentCategoriesProd = JSON.parse(data.data.getPlarformSchema.ContentCategories);
	      this.listOfPromotedContent = [];

	      localStorage.setItem('listOfLive', JSON.stringify(this.listOfLive));
	      localStorage.setItem('listOfPromotedContent', JSON.stringify(this.listOfPromotedContent));

	      let finalLists = [];
	      let newContentCategory = [];
	      let promotedContentArray = [];

	      if(this.listOfVodAssets) {
	        let perfinalList = [];
	        let list = {Name :'', Contents : []};

			for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
				if(this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate != '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == '1' ) {
				  list.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
					//sort by alphabet
					if(this.listOfAppConfiguration.Contentorder == '1') {
					  list.Contents.sort(function(a, b) {
						return a.Title[0].localeCompare(b.Title[0]);
					  });
					} else {
					  // sort by JobID
					  list.Contents.sort(function (a, b) {
						return b.JobID - a.JobID;
					  });
					}
				}
			  }

	        for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
				if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {

					if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
					  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
					  //sort by alphabet
					  if(this.listOfAppConfiguration.Contentorder == '1') {
						list.Contents.sort(function(a, b) {
						  return a.Title.localeCompare(b.Title);
						});
					  } else {
						// sort by JobID
						list.Contents.sort(function (a, b) {
						  return b.JobID - a.JobID;
						});
					  }
					}
	
				  } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {
	
					if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
					  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
					  //sort by alphabet
					  if(this.listOfAppConfiguration.Contentorder == '1') {
						list.Contents.sort(function(a, b) {
						  return a.Title.localeCompare(b.Title);
						});
					  } else {
						// sort by JobID
						list.Contents.sort(function (a, b) {
						  return b.JobID - a.JobID;
						});
					  }
					}
	
				  } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {
	
					if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
					  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
					  //sort by alphabet
					  if(this.listOfAppConfiguration.Contentorder == '1') {
						list.Contents.sort(function(a, b) {
						  return a.Title.localeCompare(b.Title);
						});
					  } else {
						// sort by JobID
						list.Contents.sort(function (a, b) {
						  return b.JobID - a.JobID;
						});
					  }
					}
	
				  } else {
					if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate != '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1'  ) {
					  list.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
					  //sort by alphabet
					  if(this.listOfAppConfiguration.Contentorder == '1') {
						list.Contents.sort(function(a, b) {
						  return a.Title.localeCompare(b.Title);
						});
					  } else {
						// sort by JobID
						list.Contents.sort(function (a, b) {
						  return b.JobID - a.JobID;
						});
					  }
					}
				  }
	        }
	        newContentCategory.push( {
	          title: 'My VOD',
	          vertical: '0'
	        })

	        if(list.Contents.length > '0') {
	          perfinalList.push(list)
	        }

	        finalLists.push(perfinalList);
	      }

	      if(this.listOfLive) {
	        let perfinalList = [];
	        let list = {Name :'', Contents : []};
	        for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
				if(this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate != '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == '0' || this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].IsVod == null)) {
	            list.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
	            //sort by alphabet
	            if(this.listOfAppConfiguration.Contentorder == '1') {
	              list.Contents.sort(function(a, b) {
	                return a.Title[0].localeCompare(b.Title[0]);
	              });
	            } else {
	              // sort by JobID
	              list.Contents.sort(function (a, b) {
	                return b.JobID - a.JobID;
	              });
	            }
	          }
	        }
	        newContentCategory.push( {
	          title: 'My LIVE',
	          vertical: '0'
	        })

	        if(list.Contents.length > '0') {
	          perfinalList.push(list)
	        }

	        finalLists.push(perfinalList);
	      }

	      if(userProfile == '21') {
	          let perfinalprivateUserContent = [];
	          let privateUserContent = {Name :'', Contents : []};
	          for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
	            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
	              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
	              //sort by alphabet
	                if(this.listOfAppConfiguration.Contentorder == '1') {
	                  privateUserContent.Contents.sort(function(a, b) {
	                    return a.Title.localeCompare(b.Title);
	                  });
	                } else {
	                  // sort by JobID
	                  privateUserContent.Contents.sort(function (a, b) {
	                    return b.JobID - a.JobID;
	                  });
	                }
	            }
	          }
	          for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
	            if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == userProfileName && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
	              privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
	              //sort by alphabet
	                if(this.listOfAppConfiguration.Contentorder == '1') {
	                  privateUserContent.Contents.sort(function(a, b) {
	                    return a.Title[0].localeCompare(b.Title[0]);
	                  });
	                } else {
	                  // sort by JobID
	                  privateUserContent.Contents.sort(function (a, b) {
	                    return b.JobID - a.JobID;
	                  });
	                }
	            }
	          }
	          newContentCategory.push( {
	            title: 'My Content',
	            vertical: '0'
	          })
	          
	          perfinalprivateUserContent.push(privateUserContent);
	          finalLists.push(perfinalprivateUserContent);
	      } else {
	        let perfinalprivateUserContent = [];
	          let privateUserContent = {Name :'', Contents : []};
	          for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
	            if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
	              privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
	              //sort by alphabet
	                if(this.listOfAppConfiguration.Contentorder == '1') {
	                  privateUserContent.Contents.sort(function(a, b) {
	                    return a.Title.localeCompare(b.Title);
	                  });
	                } else {
	                  // sort by JobID
	                  privateUserContent.Contents.sort(function (a, b) {
	                    return b.JobID - a.JobID;
	                  });
	                }
	            }
	          }
	          for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
	            if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == userProfileName && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
	              privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
	              //sort by alphabet
	                if(this.listOfAppConfiguration.Contentorder == '1') {
	                  privateUserContent.Contents.sort(function(a, b) {
	                    return a.Title[0].localeCompare(b.Title[0]);
	                  });
	                } else {
	                  // sort by JobID
	                  privateUserContent.Contents.sort(function (a, b) {
	                    return b.JobID - a.JobID;
	                  });
	                }
	            }
	          }
	          if(privateUserContent.Contents.length != '0') {
	            newContentCategory.push( {
	              title: 'My Content',
	              vertical: '0'
	            })
	          }

	          perfinalprivateUserContent.push(privateUserContent);
	          finalLists.push(perfinalprivateUserContent);
	      }

	      localStorage.setItem('promotedContentArray', JSON.stringify(promotedContentArray));

	      localStorage.setItem('newContentCategory', JSON.stringify(newContentCategory));

	      localStorage.setItem('jfinalLists', JSON.stringify(finalLists));

	      localStorage.setItem('bgColor',this.listOfAppConfiguration.Color);
		  localStorage.setItem('activeTabColor',this.listOfAppConfiguration.ActiveTab);
      	  localStorage.setItem('inactiveTabColor',this.listOfAppConfiguration.InactiveTab);
		  localStorage.setItem('contentStatsText',this.listOfAppConfiguration.Contentstats[0]);
	      localStorage.setItem('textColor',this.listOfAppConfiguration.TextColor);
	      localStorage.setItem('welcomeMsg',this.listOfAppConfiguration.WelcomeMessage[0]);
	      localStorage.setItem('contentCategories',this.listOfAppConfiguration.ContentCategories);
	      localStorage.setItem('imageBaseURI',this.listOfAppConfiguration.ImageBaseURI);
	      localStorage.setItem('videoBaseURI',this.listOfAppConfiguration.VideoBaseURI);
		  localStorage.setItem('liveVideoBaseURI',this.listOfAppConfiguration.LiveVideoBaseURI);
	      localStorage.setItem('ratingEnable',this.listOfAppConfiguration.Rating);
	      localStorage.setItem('contentStats',this.listOfAppConfiguration.Stats);
	      localStorage.setItem('durationEnable',this.listOfAppConfiguration.ContentDuration);
	      localStorage.setItem('overlayBackground',this.listOfAppConfiguration.OverlayBackground);
	      localStorage.setItem('overlayText',this.listOfAppConfiguration.OverlayText);
	      localStorage.setItem('overlayTextEnabled',this.listOfAppConfiguration.TextEnabled);
	      localStorage.setItem('imagetypeforslider',this.listOfAppConfiguration.Imagetypeforslider);
	      localStorage.setItem('imagetypeforlist',this.listOfAppConfiguration.Imagetypeforlist);
	      localStorage.setItem('imagetypeforposter',this.listOfAppConfiguration.Imagetypeforposter);
	      localStorage.setItem('bypassdetails',this.listOfAppConfiguration.Bypassdetails);
	      localStorage.setItem('myaccountemail',this.listOfAppConfiguration.Myaccountemail[0]);
	      localStorage.setItem('myaccountfirstname',this.listOfAppConfiguration.Myaccountfirstname[0]);
	      localStorage.setItem('myaccountlastname',this.listOfAppConfiguration.Myaccountlastname[0]);
	      localStorage.setItem('myaccountsubscriberid',this.listOfAppConfiguration.Myaccountsubscriberid[0]);

	      	if(window.location.pathname == '/mtab') {
				window.location.reload();
			}
	    }

	    /*if(window.location.pathname == '/mtab') {
			window.location.reload();
		}*/
    
  	}//end of noVnovaUserData
      
      displaydata(data) {
      	//alert('v-nova');
      	localStorage.setItem('isVNovaUser','1');
      	localStorage.setItem('changeIdTrigger',data.data.getPlarformSchema.Trigger);
      	var userProfile = localStorage.getItem('userProfile');
      	var userProfileName = localStorage.getItem('userProfileName');
      	var userId = localStorage.getItem('userId');
        //console.log('In Landing sub data');
        //console.log(userProfile);
        this.listOfAppConfiguration = JSON.parse(data.data.getPlarformSchema.AppConfiguration);
     	this.listOfPromotedContent = JSON.parse(data.data.getPlarformSchema.PromotedContentnew);
     	this.listOfVodAssets = JSON.parse(data.data.getPlarformSchema.VodNew);
     	this.listOfLive = JSON.parse(data.data.getPlarformSchema.Live);
	    this.listOfContentCategoriesProd = JSON.parse(data.data.getPlarformSchema.ContentCategories);
	     
     	localStorage.setItem('bgColor',this.listOfAppConfiguration.Color);
		localStorage.setItem('activeTabColor',this.listOfAppConfiguration.ActiveTab);
      	localStorage.setItem('inactiveTabColor',this.listOfAppConfiguration.InactiveTab);
		localStorage.setItem('contentStatsText',this.listOfAppConfiguration.Contentstats[0]);
	    localStorage.setItem('textColor',this.listOfAppConfiguration.TextColor);
	    localStorage.setItem('welcomeMsg',this.listOfAppConfiguration.WelcomeMessage[0]);
	    localStorage.setItem('contentCategories',this.listOfAppConfiguration.ContentCategories);
	    localStorage.setItem('imageBaseURI',this.listOfAppConfiguration.ImageBaseURI);
	    localStorage.setItem('videoBaseURI',this.listOfAppConfiguration.VideoBaseURI);
		localStorage.setItem('liveVideoBaseURI',this.listOfAppConfiguration.LiveVideoBaseURI);
	    localStorage.setItem('ratingEnable',this.listOfAppConfiguration.Rating);
	    localStorage.setItem('contentStats',this.listOfAppConfiguration.Stats);
	    localStorage.setItem('durationEnable',this.listOfAppConfiguration.ContentDuration);
	    localStorage.setItem('overlayBackground',this.listOfAppConfiguration.OverlayBackground);
	    localStorage.setItem('overlayText',this.listOfAppConfiguration.OverlayText);
	    localStorage.setItem('overlayTextEnabled',this.listOfAppConfiguration.TextEnabled);
	    localStorage.setItem('imagetypeforslider',this.listOfAppConfiguration.Imagetypeforslider);
	    localStorage.setItem('imagetypeforlist',this.listOfAppConfiguration.Imagetypeforlist);
	    localStorage.setItem('imagetypeforposter',this.listOfAppConfiguration.Imagetypeforposter);
	    localStorage.setItem('bypassdetails',this.listOfAppConfiguration.Bypassdetails);

	    localStorage.setItem('listOfLive', JSON.stringify(this.listOfLive));
	    localStorage.setItem('listOfPromotedContent', JSON.stringify(this.listOfPromotedContent));
        let promotedContentArray = [];
	    if(this.listOfPromotedContent) {
	      for( var i=0; i<this.listOfPromotedContent.length; i++) {
	        if( (this.listOfPromotedContent[i].Typeid && this.listOfPromotedContent[i].Typeid == '1') || (this.listOfPromotedContent[i].TypeID && this.listOfPromotedContent[i].TypeID == '1') || (this.listOfPromotedContent[i].TypeId && this.listOfPromotedContent[i].TypeId == '1') || (this.listOfPromotedContent[i].TypeiD && this.listOfPromotedContent[i].TypeiD == '1') ) {
	          promotedContentArray.push(this.listOfPromotedContent[i]);
	        }
	        if( ( (this.listOfPromotedContent[i].Typeid && this.listOfPromotedContent[i].Typeid == '0') || (this.listOfPromotedContent[i].TypeID && this.listOfPromotedContent[i].TypeID == '0') || (this.listOfPromotedContent[i].TypeId && this.listOfPromotedContent[i].TypeId == '0') || (this.listOfPromotedContent[i].TypeiD && this.listOfPromotedContent[i].TypeiD == '0') ) 
                  && ( (this.listOfVodAssets[this.listOfPromotedContent[i].ContentID] && this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].IsEnabled && this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].IsEnabled == '1' && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].IsPrivate != '1' || this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].IsPrivate == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].Platform == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].Platform == undefined || (this.listOfVodAssets[this.listOfPromotedContent[i].ContentID].Platform.includes("Website"))) ) 
                  || (this.listOfVodAssets[this.listOfPromotedContent[i].Contentid] && this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].IsEnabled && this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].IsEnabled == '1' && (this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].IsPrivate != '1' || this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].IsPrivate == null || this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].Platform == null || this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].Platform == undefined || (this.listOfVodAssets[this.listOfPromotedContent[i].Contentid].Platform.includes("Website"))) ) 
                  || (this.listOfVodAssets[this.listOfPromotedContent[i].ContentId] && this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].IsEnabled && this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].IsEnabled == '1' && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].IsPrivate != '1' || this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].IsPrivate == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].Platform == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].Platform == undefined || (this.listOfVodAssets[this.listOfPromotedContent[i].ContentId].Platform.includes("Website"))) ) 
                  || (this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD] && this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].IsEnabled && this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].IsEnabled == '1' && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].IsPrivate != '1' || this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].IsPrivate == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].Platform == null || this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].Platform == undefined || (this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD].Platform.includes("Website"))) ) ) ) {
	          promotedContentArray.push(this.listOfVodAssets[this.listOfPromotedContent[i].Contentid] || this.listOfVodAssets[this.listOfPromotedContent[i].ContentID] || this.listOfVodAssets[this.listOfPromotedContent[i].ContentId] || this.listOfVodAssets[this.listOfPromotedContent[i].ContentiD]);
	        }
	        //console.log(promotedContentArray);
	        localStorage.setItem('promotedContentArray', JSON.stringify(promotedContentArray));
	      }
	    }


        let finalLists = [];
	    let newContentCategory = [];
	    for(var i=0; i<Object.keys(this.listOfContentCategoriesProd).length; i++) {
	        /*For Content Category Names*/
	      	if(this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]].Status == '1') {
	        	 newContentCategory.push( {
		          title: this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]].Title[0],
		          serial: this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]].Serial,
		          Bouquet: this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]].Bouquet,
		          Status: this.listOfContentCategoriesProd[Object.keys(this.listOfContentCategoriesProd)[i]].Status,
		          vertical: '1'
		        })
		        // sort by serial
		        newContentCategory.sort(function (a, b) {
		          return a.serial - b.serial;
		        });
		    }
		}

	for(var i=0; i<newContentCategory.length; i++) {
      /*For Content Category Bouquet*/
      if(newContentCategory[i].Status == '1') {
        let listBouquets = newContentCategory[i].Bouquet
			      let perfinalList = [];
			      if(listBouquets) {
			      listBouquets.forEach((listBouquet)=>{
			        if(listBouquet.Name != null && listBouquet.ContentIdwithType !== null) {
			        let list = {Name :listBouquet.Name[0], Contents : [], contentType : []};
			        listBouquet.ContentIdwithType.forEach((Contents)=> {
						if(Contents.Type == 'VOD') {
							//console.log(Contents);
							//console.log(this.listOfVodAssets);
				 
							 if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {
				 
							   if( (this.listOfVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfVodAssets[Contents.ContentId].Codec && (this.listOfVodAssets[Contents.ContentId].Codec != '3') && (this.listOfVodAssets[Contents.ContentId].Codec != '4') && this.listOfVodAssets[Contents.ContentId].IsEnabled && this.listOfVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentId].IsPrivate == null || this.listOfVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentId].Platform == null || this.listOfVodAssets[Contents.ContentId].Platform == undefined || (this.listOfVodAssets[Contents.ContentId].Platform.includes("Website")))) 
							   || (this.listOfVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfVodAssets[Contents.ContentID].Codec && (this.listOfVodAssets[Contents.ContentID].Codec != '3') && (this.listOfVodAssets[Contents.ContentID].Codec != '4')  && this.listOfVodAssets[Contents.ContentID].IsEnabled && this.listOfVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentID].IsPrivate == null || this.listOfVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentID].Platform == null || this.listOfVodAssets[Contents.ContentID].Platform == undefined || (this.listOfVodAssets[Contents.ContentID].Platform.includes("Website"))) )
							   || (this.listOfVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfVodAssets[Contents.Contentid].Codec && (this.listOfVodAssets[Contents.Contentid].Codec != '3') && (this.listOfVodAssets[Contents.Contentid].Codec != '4') && this.listOfVodAssets[Contents.Contentid].IsEnabled && this.listOfVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfVodAssets[Contents.Contentid].IsPrivate == null || this.listOfVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfVodAssets[Contents.Contentid].Platform == null || this.listOfVodAssets[Contents.Contentid].Platform == undefined || (this.listOfVodAssets[Contents.Contentid].Platform.includes("Website")))) 
							   || (this.listOfVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfVodAssets[Contents.ContentiD].Codec && (this.listOfVodAssets[Contents.ContentiD].Codec != '3') && (this.listOfVodAssets[Contents.ContentiD].Codec != '4') && this.listOfVodAssets[Contents.ContentiD].IsEnabled && this.listOfVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentiD].Platform == null || this.listOfVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
								 
								 list.Contents.push(this.listOfVodAssets[Contents.ContentId] || this.listOfVodAssets[Contents.ContentID] || this.listOfVodAssets[Contents.Contentid] || this.listOfVodAssets[Contents.ContentiD])
								 
								 list.contentType.push( {
								   type: 'VOD',
								   contentId: Contents.ContentID
								 })
								 
								 if(this.listOfAppConfiguration.Contentorder == '1') {
								   list.Contents.sort(function(a, b) {
									 return a.Title.localeCompare(b.Title);
								   });
								 }
							   }
				 
							 } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {
				 
							   if( (this.listOfVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfVodAssets[Contents.ContentId].Codec && (this.listOfVodAssets[Contents.ContentId].Codec != '3') && (this.listOfVodAssets[Contents.ContentId].Codec != '4') && (this.listOfVodAssets[Contents.ContentId].Codec != '5') && (this.listOfVodAssets[Contents.ContentId].Codec != '9') && (this.listOfVodAssets[Contents.ContentId].Codec != '6') && (this.listOfVodAssets[Contents.ContentId].Codec != '10') && this.listOfVodAssets[Contents.ContentId].IsEnabled && this.listOfVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentId].IsPrivate == null || this.listOfVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentId].Platform == null || this.listOfVodAssets[Contents.ContentId].Platform == undefined || (this.listOfVodAssets[Contents.ContentId].Platform.includes("Website")))) 
							   || (this.listOfVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfVodAssets[Contents.ContentID].Codec && (this.listOfVodAssets[Contents.ContentID].Codec != '3') && (this.listOfVodAssets[Contents.ContentID].Codec != '4') && (this.listOfVodAssets[Contents.ContentID].Codec != '5') && (this.listOfVodAssets[Contents.ContentID].Codec != '9') && (this.listOfVodAssets[Contents.ContentID].Codec != '6') && (this.listOfVodAssets[Contents.ContentID].Codec != '10') && this.listOfVodAssets[Contents.ContentID].IsEnabled && this.listOfVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentID].IsPrivate == null || this.listOfVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentID].Platform == null || this.listOfVodAssets[Contents.ContentID].Platform == undefined || (this.listOfVodAssets[Contents.ContentID].Platform.includes("Website"))) )
							   || (this.listOfVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfVodAssets[Contents.Contentid].Codec && (this.listOfVodAssets[Contents.Contentid].Codec != '3') && (this.listOfVodAssets[Contents.Contentid].Codec != '4') && (this.listOfVodAssets[Contents.Contentid].Codec != '5') && (this.listOfVodAssets[Contents.Contentid].Codec != '9') && (this.listOfVodAssets[Contents.Contentid].Codec != '6') && (this.listOfVodAssets[Contents.Contentid].Codec != '10') && this.listOfVodAssets[Contents.Contentid].IsEnabled && this.listOfVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfVodAssets[Contents.Contentid].IsPrivate == null || this.listOfVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfVodAssets[Contents.Contentid].Platform == null || this.listOfVodAssets[Contents.Contentid].Platform == undefined || (this.listOfVodAssets[Contents.Contentid].Platform.includes("Website")))) 
							   || (this.listOfVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfVodAssets[Contents.ContentiD].Codec && (this.listOfVodAssets[Contents.ContentiD].Codec != '3') && (this.listOfVodAssets[Contents.ContentiD].Codec != '4') && (this.listOfVodAssets[Contents.ContentiD].Codec != '5') && (this.listOfVodAssets[Contents.ContentiD].Codec != '9') && (this.listOfVodAssets[Contents.ContentiD].Codec != '6') && (this.listOfVodAssets[Contents.ContentiD].Codec != '10') && this.listOfVodAssets[Contents.ContentiD].IsEnabled && this.listOfVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentiD].Platform == null || this.listOfVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
								 
								 list.Contents.push(this.listOfVodAssets[Contents.ContentId] || this.listOfVodAssets[Contents.ContentID] || this.listOfVodAssets[Contents.Contentid] || this.listOfVodAssets[Contents.ContentiD])
								 
								 list.contentType.push( {
								   type: 'VOD',
								   contentId: Contents.ContentID
								 })
								 
								 if(this.listOfAppConfiguration.Contentorder == '1') {
								   list.Contents.sort(function(a, b) {
									 return a.Title.localeCompare(b.Title);
								   });
								 }
							   }
				 
							 } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {
				 
							   if( (this.listOfVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfVodAssets[Contents.ContentId].Codec && (this.listOfVodAssets[Contents.ContentId].Codec != '5') && (this.listOfVodAssets[Contents.ContentId].Codec != '9') && (this.listOfVodAssets[Contents.ContentId].Codec != '6') && (this.listOfVodAssets[Contents.ContentId].Codec != '10') && this.listOfVodAssets[Contents.ContentId].IsEnabled && this.listOfVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentId].IsPrivate == null || this.listOfVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentId].Platform == null || this.listOfVodAssets[Contents.ContentId].Platform == undefined || (this.listOfVodAssets[Contents.ContentId].Platform.includes("Website")))) 
							   || (this.listOfVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfVodAssets[Contents.ContentID].Codec && (this.listOfVodAssets[Contents.ContentID].Codec != '5') && (this.listOfVodAssets[Contents.ContentID].Codec != '9') && (this.listOfVodAssets[Contents.ContentID].Codec != '6') && (this.listOfVodAssets[Contents.ContentID].Codec != '10') && this.listOfVodAssets[Contents.ContentID].IsEnabled && this.listOfVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentID].IsPrivate == null || this.listOfVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentID].Platform == null || this.listOfVodAssets[Contents.ContentID].Platform == undefined || (this.listOfVodAssets[Contents.ContentID].Platform.includes("Website"))) )
							   || (this.listOfVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfVodAssets[Contents.Contentid].Codec && (this.listOfVodAssets[Contents.Contentid].Codec != '5') && (this.listOfVodAssets[Contents.Contentid].Codec != '9') && (this.listOfVodAssets[Contents.Contentid].Codec != '6') && (this.listOfVodAssets[Contents.Contentid].Codec != '10') && this.listOfVodAssets[Contents.Contentid].IsEnabled && this.listOfVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfVodAssets[Contents.Contentid].IsPrivate == null || this.listOfVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfVodAssets[Contents.Contentid].Platform == null || this.listOfVodAssets[Contents.Contentid].Platform == undefined || (this.listOfVodAssets[Contents.Contentid].Platform.includes("Website")))) 
							   || (this.listOfVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfVodAssets[Contents.ContentiD].Codec && (this.listOfVodAssets[Contents.ContentiD].Codec != '5') && (this.listOfVodAssets[Contents.ContentiD].Codec != '9') && (this.listOfVodAssets[Contents.ContentiD].Codec != '6') && (this.listOfVodAssets[Contents.ContentiD].Codec != '10') && this.listOfVodAssets[Contents.ContentiD].IsEnabled && this.listOfVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentiD].Platform == null || this.listOfVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
								 
								 list.Contents.push(this.listOfVodAssets[Contents.ContentId] || this.listOfVodAssets[Contents.ContentID] || this.listOfVodAssets[Contents.Contentid] || this.listOfVodAssets[Contents.ContentiD])
								 
								 list.contentType.push( {
								   type: 'VOD',
								   contentId: Contents.ContentID
								 })
								 
								 if(this.listOfAppConfiguration.Contentorder == '1') {
								   list.Contents.sort(function(a, b) {
									 return a.Title.localeCompare(b.Title);
								   });
								 }
							   }
				 
							 } else {
				 
							   if( (this.listOfVodAssets.hasOwnProperty(Contents.ContentId) && this.listOfVodAssets[Contents.ContentId].IsEnabled && this.listOfVodAssets[Contents.ContentId].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentId].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentId].IsPrivate == null || this.listOfVodAssets[Contents.ContentId].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentId].Platform == null || this.listOfVodAssets[Contents.ContentId].Platform == undefined || (this.listOfVodAssets[Contents.ContentId].Platform.includes("Website")))) 
							   || (this.listOfVodAssets.hasOwnProperty(Contents.ContentID) && this.listOfVodAssets[Contents.ContentID].IsEnabled && this.listOfVodAssets[Contents.ContentID].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentID].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentID].IsPrivate == null || this.listOfVodAssets[Contents.ContentID].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentID].Platform == null || this.listOfVodAssets[Contents.ContentID].Platform == undefined || (this.listOfVodAssets[Contents.ContentID].Platform.includes("Website"))) )
							   || (this.listOfVodAssets.hasOwnProperty(Contents.Contentid) && this.listOfVodAssets[Contents.Contentid].IsEnabled && this.listOfVodAssets[Contents.Contentid].IsEnabled == '1' && (this.listOfVodAssets[Contents.Contentid].IsPrivate != '1' || this.listOfVodAssets[Contents.Contentid].IsPrivate == null || this.listOfVodAssets[Contents.Contentid].IsPrivate == undefined) &&(this.listOfVodAssets[Contents.Contentid].Platform == null || this.listOfVodAssets[Contents.Contentid].Platform == undefined || (this.listOfVodAssets[Contents.Contentid].Platform.includes("Website")))) 
							   || (this.listOfVodAssets.hasOwnProperty(Contents.ContentiD) && this.listOfVodAssets[Contents.ContentiD].IsEnabled && this.listOfVodAssets[Contents.ContentiD].IsEnabled == '1' && (this.listOfVodAssets[Contents.ContentiD].IsPrivate != '1' || this.listOfVodAssets[Contents.ContentiD].IsPrivate == null || this.listOfVodAssets[Contents.ContentiD].IsPrivate == undefined) && (this.listOfVodAssets[Contents.ContentiD].Platform == null || this.listOfVodAssets[Contents.ContentiD].Platform == undefined || (this.listOfVodAssets[Contents.ContentiD].Platform.includes("Website")))) ){
								 
								 list.Contents.push(this.listOfVodAssets[Contents.ContentId] || this.listOfVodAssets[Contents.ContentID] || this.listOfVodAssets[Contents.Contentid] || this.listOfVodAssets[Contents.ContentiD])
								 
								 list.contentType.push( {
								   type: 'VOD',
								   contentId: Contents.ContentID
								 })
								 
								 if(this.listOfAppConfiguration.Contentorder == '1') {
								   list.Contents.sort(function(a, b) {
									 return a.Title.localeCompare(b.Title);
								   });
								 }
							   }
				 
							 }
				 
							} else {
			                if( (this.listOfLive.hasOwnProperty(Contents.ContentId) && this.listOfLive[Contents.ContentId].IsEnabled && this.listOfLive[Contents.ContentId].IsEnabled == '1' && (this.listOfLive[Contents.ContentId].IsPrivate != '1' || this.listOfLive[Contents.ContentId].IsPrivate == null || this.listOfLive[Contents.ContentId].IsPrivate == undefined) && (this.listOfLive[Contents.ContentId].AppPlatforms == null || this.listOfLive[Contents.ContentId].AppPlatforms == undefined || (this.listOfLive[Contents.ContentId].AppPlatforms.includes("Website")))) || (this.listOfLive.hasOwnProperty(Contents.ContentID) && this.listOfLive[Contents.ContentID].IsEnabled && this.listOfLive[Contents.ContentID].IsEnabled == '1' && (this.listOfLive[Contents.ContentID].IsPrivate != '1' || this.listOfLive[Contents.ContentID].IsPrivate == null || this.listOfLive[Contents.ContentID].IsPrivate == undefined) && (this.listOfLive[Contents.ContentID].AppPlatforms == null || this.listOfLive[Contents.ContentID].AppPlatforms == undefined || (this.listOfLive[Contents.ContentID].AppPlatforms.includes("Website"))) ) || (this.listOfLive.hasOwnProperty(Contents.Contentid) && this.listOfLive[Contents.Contentid].IsEnabled && this.listOfLive[Contents.Contentid].IsEnabled == '1' && (this.listOfLive[Contents.Contentid].IsPrivate != '1' || this.listOfLive[Contents.Contentid].IsPrivate == null || this.listOfLive[Contents.Contentid].IsPrivate == undefined) &&(this.listOfLive[Contents.Contentid].AppPlatforms == null || this.listOfLive[Contents.Contentid].AppPlatforms == undefined || (this.listOfLive[Contents.Contentid].AppPlatforms.includes("Website")))) || (this.listOfLive.hasOwnProperty(Contents.ContentiD) && this.listOfLive[Contents.ContentiD].IsEnabled && this.listOfLive[Contents.ContentiD].IsEnabled == '1' && (this.listOfLive[Contents.ContentiD].IsPrivate != '1' || this.listOfLive[Contents.ContentiD].IsPrivate == null || this.listOfLive[Contents.ContentiD].IsPrivate == undefined) && (this.listOfLive[Contents.ContentiD].AppPlatforms == null || this.listOfLive[Contents.ContentiD].AppPlatforms == undefined || (this.listOfLive[Contents.ContentiD].AppPlatforms.includes("Website")))) ){
			                  	list.Contents.push(this.listOfLive[Contents.ContentId] || this.listOfLive[Contents.ContentID] || this.listOfLive[Contents.Contentid] || this.listOfLive[Contents.ContentiD] )
								  list.contentType.push( {
									type: Contents.Type,
									contentId: Contents.ContentID
								  })
								if(this.listOfAppConfiguration.Contentorder == '1') {
					            	list.Contents.sort(function(a, b) {
						              return a.Title[0].localeCompare(b.Title[0]);
						            });
					            }
			              }
			              
			            } 
			        });
			        
			        if(list.Contents.length > '0') {
			          perfinalList.push(list)
			        }
			        } 
			      });
			  }
			        finalLists.push(perfinalList);
			       //console.log(finalLists);
			}
	   	}

	   	if(userProfile == '21') {
        let perfinalprivateUserContent = [];
        let privateUserContent = {Name :'My Content', Contents : []};
        for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
			if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {
				if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
				  privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
				  if(this.listOfAppConfiguration.Contentorder == '1') {
					privateUserContent.Contents.sort(function(a, b) {
					  return a.Title.localeCompare(b.Title);
					});
				  } else {
					privateUserContent.Contents.sort(function (a, b) {
					  return b.JobID - a.JobID;
					});
				  }
				}
			  } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {
				if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
				  privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
				  if(this.listOfAppConfiguration.Contentorder == '1') {
					privateUserContent.Contents.sort(function(a, b) {
					  return a.Title.localeCompare(b.Title);
					});
				  } else {
					privateUserContent.Contents.sort(function (a, b) {
					  return b.JobID - a.JobID;
					});
				  }
				}
			  } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {
				if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
				  privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
				  if(this.listOfAppConfiguration.Contentorder == '1') {
					privateUserContent.Contents.sort(function(a, b) {
					  return a.Title.localeCompare(b.Title);
					});
				  } else {
					privateUserContent.Contents.sort(function (a, b) {
					  return b.JobID - a.JobID;
					});
				  }
				}
			  } else {
				if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
				  privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
				  if(this.listOfAppConfiguration.Contentorder == '1') {
					privateUserContent.Contents.sort(function(a, b) {
					  return a.Title.localeCompare(b.Title);
					});
				  } else {
					privateUserContent.Contents.sort(function (a, b) {
					  return b.JobID - a.JobID;
					});
				  }
				}
			  }
        }
        for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
          if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == userProfileName && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
            privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
          	if(this.listOfAppConfiguration.Contentorder == '1') {
              privateUserContent.Contents.sort(function(a, b) {
                return a.Title[0].localeCompare(b.Title[0]);
              });
            } else {
				privateUserContent.Contents.sort(function (a, b) {
				  return b.JobID - a.JobID;
				});
			}
          }
        }
        newContentCategory.push( {
          title: 'My Content',
          vertical: '0'
        })
        /*if(privateUserContent.Contents.length != '0') {
          newContentCategory.push('My Content');
        }*/
        perfinalprivateUserContent.push(privateUserContent);
        finalLists.push(perfinalprivateUserContent);
    } else {
      let perfinalprivateUserContent = [];
        let privateUserContent = {Name :'My Content', Contents : []};
        for(var i=0; i<Object.keys(this.listOfVodAssets).length; i++) {
			if (this.isHEVCSupport == "false" && this.isAV1Support == "true") {
				if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
				  privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
				  if(this.listOfAppConfiguration.Contentorder == '1') {
					privateUserContent.Contents.sort(function(a, b) {
					  return a.Title.localeCompare(b.Title);
					});
				  } else {
					privateUserContent.Contents.sort(function (a, b) {
					  return b.JobID - a.JobID;
					});
				  }
				}
			  } else if (this.isHEVCSupport == "false" && this.isAV1Support == "false") {
				if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '3') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '4') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
				  privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
				  if(this.listOfAppConfiguration.Contentorder == '1') {
					privateUserContent.Contents.sort(function(a, b) {
					  return a.Title.localeCompare(b.Title);
					});
				  } else {
					privateUserContent.Contents.sort(function (a, b) {
					  return b.JobID - a.JobID;
					});
				  }
				}
			  } else if (this.isHEVCSupport == "true" && this.isAV1Support == "false") {
				if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '5') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '9') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '6') && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Codec != '10') && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
				  privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
				  if(this.listOfAppConfiguration.Contentorder == '1') {
					privateUserContent.Contents.sort(function(a, b) {
					  return a.Title.localeCompare(b.Title);
					});
				  } else {
					privateUserContent.Contents.sort(function (a, b) {
					  return b.JobID - a.JobID;
					});
				  }
				}
			  } else {
				if(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].User == userProfileName && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].UserID == userId && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsPrivate == '1' && this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].IsEnabled == '1' && (this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == null || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform == undefined || this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]].Platform.includes("Website")) ) {
				  privateUserContent.Contents.push(this.listOfVodAssets[Object.keys(this.listOfVodAssets)[i]])
				  if(this.listOfAppConfiguration.Contentorder == '1') {
					privateUserContent.Contents.sort(function(a, b) {
					  return a.Title.localeCompare(b.Title);
					});
				  } else {
					privateUserContent.Contents.sort(function (a, b) {
					  return b.JobID - a.JobID;
					});
				  }
				}
			}
        }
        for(var i=0; i<Object.keys(this.listOfLive).length; i++) {
          if(this.listOfLive[Object.keys(this.listOfLive)[i]].User == userProfileName && this.listOfLive[Object.keys(this.listOfLive)[i]].UserID == userId && this.listOfLive[Object.keys(this.listOfLive)[i]].IsPrivate == '1' && this.listOfLive[Object.keys(this.listOfLive)[i]].IsEnabled == '1' && (this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == null || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms == undefined || this.listOfLive[Object.keys(this.listOfLive)[i]].AppPlatforms.includes("Website")) ) {
            privateUserContent.Contents.push(this.listOfLive[Object.keys(this.listOfLive)[i]])
          	if(this.listOfAppConfiguration.Contentorder == '1') {
              privateUserContent.Contents.sort(function(a, b) {
                return a.Title[0].localeCompare(b.Title[0]);
              });
            } else {
				privateUserContent.Contents.sort(function (a, b) {
				  return b.JobID - a.JobID;
				});
			}
          }
        }
        if(privateUserContent.Contents.length != '0') {
          newContentCategory.push( {
            title: 'My Content',
            vertical: '0'
          })
        }

        perfinalprivateUserContent.push(privateUserContent);
        finalLists.push(perfinalprivateUserContent);
    }

     //console.log(newContentCategory);
    localStorage.setItem('newContentCategory', JSON.stringify(newContentCategory));

     //console.log(finalLists);
    localStorage.setItem('jfinalLists', JSON.stringify(finalLists));
  
  		if(window.location.pathname == '/mtab') {
    		window.location.reload();
    	}
    }

  	render() {
  		var newContentCategory = JSON.parse(localStorage.getItem("newContentCategory"));
  		var listOfPromotedContent = JSON.parse(localStorage.getItem("listOfPromotedContent"));
  		//var promotedContentArray = JSON.parse(localStorage.getItem("promotedContentArray"));
  		var jfinalLists = JSON.parse(localStorage.getItem("jfinalLists"));
  		var listOfLive = JSON.parse(localStorage.getItem("listOfLive"));

		var listOfDemoCntLive = JSON.parse(localStorage.getItem("listOfDemoCntLive"));

  		var bypassdetails = localStorage.getItem("bypassdetails");
  		var isStaging = localStorage.getItem('isStaging');
  		var imageCacheValue = localStorage.getItem('imageCacheValue');
  		var isVNovaUser = localStorage.getItem('isVNovaUser');

		var activeTabColor = localStorage.getItem("activeTabColor");
		var inactiveTabColor = localStorage.getItem("inactiveTabColor");

		if(this.state.showPromoContent == '0') {
			var promotedContentArray = [];
		} else {
		  if(listOfPromotedContent && listOfPromotedContent.length > 0) {
			  var promotedContentArray = JSON.parse(localStorage.getItem("promotedContentArray"));
		  } else {
			  var promotedContentArray = [];
		  }
		}

  		var urlTabName = localStorage.getItem("urlTabName");
  		var urltab = localStorage.getItem("urltab");

  		if( (urlTabName <= '0') || (urlTabName > (newContentCategory.length)) ) {
  			window.$('a[href="#0"]').addClass("selectedTab").show();
			window.$(".tab-content #0").addClass("active in").show();
			window.$("#0 .no_content_text:not(:first)").remove();

			window.$('a[href^="#"]').each(function () {
				this.style.setProperty('color', inactiveTabColor, 'important');
			});
			
			 const activeElement = window.$(`a[href="#${this.state.activeInfo}"]`)[0];
			if (activeElement) {
				activeElement.style.setProperty(
					'color',
					activeTabColor,
					'important'
				);
				activeElement.style.setProperty(
					'border-bottom',
					`2px solid ${activeTabColor}`,
					'important'
				);
			}

  		} else {
  			if(urlTabName !== "undefined" && urlTabName !== null && urltab == '1') {
  			newContentCategory.forEach((elem, index) => {
			  	if(index == (urlTabName - 1) ) {
			  		window.$('a[href="#' + index + '"]').addClass("selectedTab").show();
			  		window.$(".tab-content #"+index).addClass("active in").show();
			  		window.$("#"+index+" .no_content_text:not(:first)").remove();

					window.$('a[href^="#"]').each(function () {
						this.style.setProperty('color', inactiveTabColor, 'important');
						this.style.setProperty('border-bottom', 'none', 'important');
					});
			
					const activeElement = window.$(`a[href="#${index}"]`)[0];
					if (activeElement) {
						activeElement.style.setProperty(
							'color',
							activeTabColor,
							'important'
						);
						activeElement.style.setProperty(
							'border-bottom',
							`2px solid ${activeTabColor}`,
							'important'
						);
					}

			  	}
			});
	  		} else {
	  			window.$('a[href="#0"]').addClass("selectedTab").show();
				window.$(".tab-content #0").addClass("active in").show();
				window.$("#0 .no_content_text:not(:first)").remove();

				window.$('a[href^="#"]').each(function () {
					this.style.setProperty('color', inactiveTabColor, 'important');
				});
				
				const activeElement = window.$(`a[href="#${this.state.activeInfo}"]`)[0];
				if (activeElement) {
					activeElement.style.setProperty(
						'color',
						activeTabColor,
						'important'
					);
					activeElement.style.setProperty(
						'border-bottom',
						`2px solid ${activeTabColor}`,
						'important'
					);
				}
				
	  		}
			
  		}

		window.$('a[data-toggle="tab"]').on('show.bs.tab', function(e) {
		localStorage.setItem('activeTab', window.$(e.target).attr('href'));
		});
		var activeTab = localStorage.getItem('activeTab');
		if(activeTab){
			if(activeTab != '#0') {
				window.$('a[href="#0"]').removeClass("selectedTab");
				window.$(activeTab + ".no_content_text:not(:first)").remove();
			}
			window.$('a[href="' + activeTab + '"]').addClass("selectedTab").show();
			window.$('#myTab a[href="' + activeTab + '"]').tab('show');

			window.$('a[href^="#"]').each(function () {
				this.style.setProperty('color', inactiveTabColor, 'important');
				this.style.setProperty('border-bottom', 'none', 'important');
			});
			
			const activeElement = window.$(`a[href="#${this.state.activeInfo}"]`)[0];
			if (activeElement) {
				activeElement.style.setProperty(
					'color',
					activeTabColor,
					'important'
				);
				activeElement.style.setProperty(
					'border-bottom',
					`2px solid ${activeTabColor}`,
					'important'
				);
			}

		}

		this.setActive = (info,contentCategory) => (event) => {

			this.setState({
				activeInfo : info
			});
			localStorage.setItem('activeInfo', info);

			if(contentCategory.vertical == '0') {
				this.setState({
		            showPromoContent : '0'
		        });
		        localStorage.setItem('verticalContent', '0');
			} else {
				this.setState({
		            showPromoContent : '1'
		        });
		       localStorage.setItem('verticalContent', '1');
			}
			localStorage.setItem('urltab', '0');
			this.setState({
	            noSearchData : 'false'
	        });
			var serachValue = document.getElementById( 'search_input' ).value;
			var serachValueSmall = document.getElementById( 'search_input_small' ).value;
			if(serachValue.length > '0' && this.state.searchData.length > '0') {
				window.$('a[href="' + activeTab + '"]').addClass("selectedTab").show();
				window.$('#myTab a[href="' + activeTab + '"]').tab('show');
				this.clearSearch();
			} else if (serachValueSmall.length > '0' && this.state.searchData.length > '0') {
				window.$('a[href="' + activeTab + '"]').addClass("selectedTab").show();
				window.$('#myTab a[href="' + activeTab + '"]').tab('show');
				this.clearSearch();
			} else if(serachValue.length > '0') {
				document.getElementById( 'search_input' ).value = "";
				window.$('a').removeClass("selectedTab");
				window.$('a[href="#' + info + '"]').addClass("selectedTab").show();
				
				window.$('a[href^="#"]').each(function () {
					this.style.setProperty('color', inactiveTabColor, 'important');
					this.style.setProperty('border-bottom', 'none', 'important');
				});

			 	const activeElement = window.$('a[href="#' + info + '"]')[0];
				if (activeElement) {
					activeElement.style.setProperty(
						'color',
						activeTabColor,
						'important'
					);
					activeElement.style.setProperty(
						'border-bottom',
						`2px solid ${activeTabColor}`,
						'important'
					);
				}
			} else if(serachValueSmall.length > '0') {
				document.getElementById( 'search_input_small' ).value = "";
				window.$('a').removeClass("selectedTab");
				window.$('a[href="#' + info + '"]').addClass("selectedTab").show();
				
				window.$('a[href^="#"]').each(function () {
					this.style.setProperty('color', inactiveTabColor, 'important');
					this.style.setProperty('border-bottom', 'none', 'important');
				});

			 	const activeElement = window.$('a[href="#' + info + '"]')[0];
				if (activeElement) {
					activeElement.style.setProperty(
						'color',
						activeTabColor,
						'important'
					);
					activeElement.style.setProperty(
						'border-bottom',
						`2px solid ${activeTabColor}`,
						'important'
					);
				}
			}
			else {
				window.$('a').removeClass("selectedTab");
				window.$('a[href="#' + info + '"]').addClass("selectedTab").show();
				
				window.$('a[href^="#"]').each(function () {
					this.style.setProperty('color', inactiveTabColor, 'important');
					this.style.setProperty('border-bottom', 'none', 'important');
				});
 				
				const activeElement = window.$('a[href="#' + info + '"]')[0];
				if (activeElement) {
					activeElement.style.setProperty(
						'color',
						activeTabColor,
						'important'
					);
					activeElement.style.setProperty(
						'border-bottom',
						`2px solid ${activeTabColor}`,
						'important'
					);
				}
			}
			
		}
		
  		 		
	  	const parentdiv = {
		  backgroundColor: this.state.bgColor,
		  color: this.state.textColor,
		  minHeight: '100vh',
		}
		const colors = {
		  backgroundColor: this.state.bgColor,
		  color: this.state.textColor,
		}

		const activetabColor = {
		  color: this.state.activeTabColor,
		}

		const inactivetabColor = {
		  color: this.state.inactiveTabColor,
		}

		const assetOverlaybg = {
			backgroundColor : this.state.overlayBackground
		}
		const assetOverlaytext = {
			color : this.state.overlayText
		}
		const tabNamepos = {
			display: 'flex',
			padding: '0px 0px'
		}
		const tabNameul= {
			paddingTop: '8px',
			width: '95%',
			textAlign: 'initial'
		}
		const tabNameulsmall= {
			paddingTop: '8px',
			paddingLeft: '8px',
			width: '100%',
			textAlign: 'initial'
		}
		
		var tabSlideConfig = {
			dots: false,
			infinite: false,
			speed: 500,
			slidesToShow: 7,
			slidesToScroll: 1,
			initialSlide: 0,
			responsive: [
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 7,
						slidesToScroll: 1,
						infinite: false,
						dots: false
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 6,
						slidesToScroll: 1,
						infinite: false,
						dots: false
					}
				},
				{
					breakpoint: 1050,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
						infinite: false,
						dots: false
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
						infinite: false,
						dots: false
					}
				},
				{
					breakpoint: 776,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 1,
						infinite: false,
						dots: false
					}
				},
				{
					breakpoint: 550,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
						infinite: false,
						dots: false
					}
				},
				{
					breakpoint: 550,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
						infinite: false,
						dots: false
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: false,
						dots: false
					}
				},
				{
					breakpoint: 350,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: false,
						dots: false
					}
				},
				{
					breakpoint: 300,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: false,
						dots: false
					}
				},
			]
		};

		var promSlideConfig = {
			dots: true,
			pauseOnHover: true,
		    infinite: true,
		    speed: 1000,
		    autoplay: true,
		    autoplaySpeed: 6000,
		    fade: false,
			slidesToShow: 1,
			slidesToScroll: 1
		};

		var slideConfig = {
			dots: false,
			infinite: false,
			speed: 500,
			slidesToShow: 5,
			slidesToScroll: 1,
			initialSlide: 0,
			responsive: [
			{
				breakpoint: 350,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},
			{
				breakpoint: 450,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},
			{
				breakpoint: 570,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},
			{
				breakpoint: 770,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},
			{
				breakpoint: 980,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},
			/*{
				breakpoint: 1200,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},*/
			{
				breakpoint: 1300,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},
			{
				breakpoint: 1500,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			},
			{
				breakpoint: 1800,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: false,
					dots: false
				}
			}
			]
		};


	this.logout = () => (event) => {
		event.preventDefault();
		localStorage.clear();
	    this.props.history.push('/')
	}

	this.goToLcevcplayer = () => (event) => {
		event.preventDefault();
		localStorage.setItem('fromLandingToLaunch', '1');
	    this.props.history.push('/lcevcplayer')
	}

	this.goToExperienceplayer = () => (event) => {
		event.preventDefault();
	    this.props.history.push('/experience')
	}

	this.goToSplitScreenplayer = () => (event) => {
		event.preventDefault();
		window.location.href = '/split.html';
	}

	this.goToAccount = () => (event) => {
		event.preventDefault();
	    this.props.history.push('/account')
	}

	this.goToAbout = () => (event) => {
		event.preventDefault();
	    this.props.history.push('/about')
	}

	this.goToHomeWebsite = () => (event) => {
		event.preventDefault();
		window.open("https://www.v-nova.com/", "_blank");
	}

	this.goToWebAdv = (info) => (event) => {
		event.preventDefault();
   		window.location.href = info.Weburl;
	}

	this.toggleWelcomepopup = () => (event) => {
	    //console.log(event.target.checked);
	    if (event.target.checked) {
	      document.cookie = "welcomePopup=1";
	    } 
	}

	this.onListError = (event,contentId)  => {
		//console.log(contentId);
		//console.log(event);
		event.target.src = replacement;
        fetch(this.state.imageBaseURI +'images/' +contentId+'.png').then(response => {
         //console.log(response)
          if(response.ok) {
            event.target.src = this.state.imageBaseURI +'images/' +contentId+'.png';
          } else {
            //console.log(event);
            event.target.style.height = 'auto';
            event.target.src = replacement;
          }
        });
      }

   	this.goToContentDetails = (info) => (event) => {
   		event.preventDefault();
   		//console.log(info);
   		if (info.Metadata) {
   		fetch(this.state.imageBaseURI + info.Metadata, {
        	method: 'GET',
      	}).then(response =>  response.json())
        .then(resData => {

          if (bypassdetails == '1') {
   			//Go to Player
   			localStorage.setItem('manifestURL', resData.ManifestURL);
        	localStorage.setItem('title', resData.Title);
        	localStorage.setItem('external', resData.IsExternal);
        	localStorage.setItem('isP3Content', resData.IsP3);
        	if(listOfLive.hasOwnProperty(resData.ContentId) || listOfLive.hasOwnProperty(resData.ContentID)) {
   				localStorage.setItem('categoryName', 'live');
   			} else {
   				localStorage.setItem('categoryName', 'asset');
   			}
			localStorage.setItem('rateControl', resData.RateControl);
			if(resData.Profiles) {
				localStorage.setItem('contentProfiles',  JSON.stringify(resData.Profiles));
			} else {
				localStorage.setItem('contentProfiles',  'null');
			}
       		
       		localStorage.setItem('fromContent', '1');
       		//Redirect to shaka player
       		this.props.history.push('/player')
            /*if(window.Hls.isSupported()) {
              this.props.history.push('/player')
            } else if (window.shaka.Player.isBrowserSupported()) {
              this.props.history.push('/splayer')
            } else {
            	this.props.history.push('/vplayer')
            }*/

   		} else {
   			if(listOfLive.hasOwnProperty(resData.ContentId) || listOfLive.hasOwnProperty(resData.ContentID)) {
   				localStorage.setItem('title', resData.Title[0]);
   				localStorage.setItem('categoryName', 'live');
   			} else {
   				localStorage.setItem('title', resData.Title);
   				localStorage.setItem('categoryName', 'asset');
   			}
   			if(listOfLive.hasOwnProperty(resData.ContentId) || listOfLive.hasOwnProperty(resData.ContentID)) {
   				localStorage.setItem('description', resData.Description[0]);
   			} else {
   				localStorage.setItem('description', resData.Description);
   			}
   			if(resData.ContentId) {
   				localStorage.setItem('contentId', resData.ContentId);
   			} else {
   				localStorage.setItem('contentId', resData.ContentID);
   			}
		    
		    localStorage.setItem('contentUrl', resData.ManifestURL);
		    if(resData.GraphicAssets) {
		    	localStorage.setItem('graphicAssets', JSON.stringify(resData.GraphicAssets));
		    }
		    localStorage.setItem('contentImage', resData.ThumbnailImage);
		    localStorage.setItem('contentImagePpro', resData.ThumbnailImagePpro);
		    localStorage.setItem('contentPosterImagePpro', resData.PosterImagePpro);
		    localStorage.setItem('contentPosterImage', resData.PosterImage);
		    localStorage.setItem('duration', resData.ContentDuration);
		    localStorage.setItem('rating', resData.Rating);
		    localStorage.setItem('premium', resData.IsPremium);
		    localStorage.setItem('external', resData.IsExternal);
		    localStorage.setItem('isP3Content', resData.IsP3);
		    localStorage.setItem('chunksize', resData.Chunksize);
		    localStorage.setItem('packaging', resData.Packaging);
		    localStorage.setItem('codec', resData.Codec);
			localStorage.setItem('rateControl', resData.RateControl);
		    if(resData.Profiles) {
		    	localStorage.setItem('contentProfiles',  JSON.stringify(resData.Profiles));
		    } else {
				localStorage.setItem('contentProfiles',  'null');
			}
		    this.props.history.push('/contentdetails')
   		}

   		// console.log(resData);
   		if(promotedContentArray.length > '0') {
   		for(var i=0; i<promotedContentArray.length; i++) {
   			if( (resData.ContentId && resData.ContentId == promotedContentArray[i].ContentId) || (resData.ContentID && resData.ContentID == promotedContentArray[i].ContentID) || (resData.ContentID && resData.ContentID == promotedContentArray[i].ContentId) ) {
   				promotedContentArray[i] = (resData);
   			}
   		}
   		localStorage.setItem('promotedContentArray', JSON.stringify(promotedContentArray));
   		}
        for(var i=0; i<jfinalLists.length; i++) {
        	if(jfinalLists[i].length > 0) {
        		for(var j=0; j<jfinalLists[i].length; j++) {
        			for(var k=0; k<jfinalLists[i][j].Contents.length; k++) {
        				if( (resData.ContentId && resData.ContentId == jfinalLists[i][j].Contents[k].ContentId) || (resData.ContentID && resData.ContentID == jfinalLists[i][j].Contents[k].ContentID) || (resData.ContentID && resData.ContentID == jfinalLists[i][j].Contents[k].ContentId) ) {
        					jfinalLists[i][j].Contents[k] = (resData);
        				}
        			}
        		}
        	}
        }
        localStorage.setItem('jfinalLists', JSON.stringify(jfinalLists));
        }).catch(error => alert('Something went wrong. Please try again.'));

        } else {
        	if (bypassdetails == '1') {
   			//Go to Player
   			localStorage.setItem('manifestURL', info.ManifestURL);
        	localStorage.setItem('title', info.Title);
        	localStorage.setItem('external', info.IsExternal);
        	localStorage.setItem('isP3Content', info.IsP3);
       		
			if(typeof info.IsVod === "undefined") {
									
				localStorage.setItem('title', info.Title);
				localStorage.setItem('categoryName', 'asset');

				if(listOfLive.hasOwnProperty(info.ContentId) || listOfLive.hasOwnProperty(info.ContentID)) {
					localStorage.setItem('description', info.Description[0]);
				} else {
					localStorage.setItem('description', info.Description);
				}

				for(var i=0; i<newContentCategory.length; i++) {
					if(newContentCategory[i].Bouquet){
						for(var j=0; j<newContentCategory[i].Bouquet.length; j++) {
							if ( (newContentCategory[i].Bouquet[j].ContentID) && ((newContentCategory[i].Bouquet[j].ContentID).includes(info.ContentID)) ) {

								if(newContentCategory[i].Bouquet[j].ContentIdwithType){
								for(var k=0; k<newContentCategory[i].Bouquet[j].ContentIdwithType.length; k++) {

									if ( (newContentCategory[i].Bouquet[j].ContentIdwithType[k].ContentID == info.ContentID)| (newContentCategory[i].Bouquet[j].ContentIdwithType[k].ContentID == info.ContentId) ) {
										if (newContentCategory[i].Bouquet[j].ContentIdwithType[k].Type == "LIVE" || newContentCategory[i].Bouquet[j].ContentIdwithType[k].Type == "ELIVE") {
											localStorage.setItem('categoryName', 'live');
										} else if ( newContentCategory[i].Bouquet[j].ContentIdwithType[k].Type == "EVOD") { 
											localStorage.setItem('categoryName', 'asset');
										} else {
											localStorage.setItem('categoryName', 'asset');
										}
									}
								}
							}
							}
						}
					}
				}
			} else if (info.IsVod == null) {
				localStorage.setItem('categoryName', 'live');

			} else if(info.IsVod == '1'){
				localStorage.setItem('categoryName', 'asset');

			} else if(info.IsVod == '0'){
				localStorage.setItem('categoryName', 'live');
			}

			localStorage.setItem('rateControl', info.RateControl);
			if (info.Profiles) {
				localStorage.setItem('contentProfiles',  JSON.stringify(info.Profiles));
			} else {
				localStorage.setItem('contentProfiles',  'null');
			}

       		localStorage.setItem('fromContent', '1');
       		//Redirect to shaka player
       		this.props.history.push('/player')
            /*if(window.Hls.isSupported()) {
              this.props.history.push('/player')
            } else if (window.shaka.Player.isBrowserSupported()) {
              this.props.history.push('/splayer')
            } else {
            	this.props.history.push('/vplayer')
            }*/
	   		} else {


				if(typeof info.IsVod === "undefined") {
									
					localStorage.setItem('title', info.Title);
					localStorage.setItem('categoryName', 'asset');

					if(listOfLive.hasOwnProperty(info.ContentId) || listOfLive.hasOwnProperty(info.ContentID)) {
						localStorage.setItem('description', info.Description[0]);
					} else {
						localStorage.setItem('description', info.Description);
					}

					for(var i=0; i<newContentCategory.length; i++) {
						if(newContentCategory[i].Bouquet){
							for(var j=0; j<newContentCategory[i].Bouquet.length; j++) {
								if ( (newContentCategory[i].Bouquet[j].ContentID) && ((newContentCategory[i].Bouquet[j].ContentID).includes(info.ContentID)) ) {

									if(newContentCategory[i].Bouquet[j].ContentIdwithType){
									for(var k=0; k<newContentCategory[i].Bouquet[j].ContentIdwithType.length; k++) {

										if ( (newContentCategory[i].Bouquet[j].ContentIdwithType[k].ContentID == info.ContentID)| (newContentCategory[i].Bouquet[j].ContentIdwithType[k].ContentID == info.ContentId) ) {
											if (newContentCategory[i].Bouquet[j].ContentIdwithType[k].Type == "LIVE" || newContentCategory[i].Bouquet[j].ContentIdwithType[k].Type == "ELIVE") {
												localStorage.setItem('title', info.Title[0]);
												localStorage.setItem('categoryName', 'live');
											} else if ( newContentCategory[i].Bouquet[j].ContentIdwithType[k].Type == "EVOD") { 
												localStorage.setItem('title', info.Title[0]);
												localStorage.setItem('categoryName', 'asset');
											} else {
												localStorage.setItem('title', info.Title);
												localStorage.setItem('categoryName', 'asset');
											}
										}
									}
								}
								}
							}
						}
					}
				} else if (info.IsVod == null) {
					localStorage.setItem('title', info.Title[0]);
					localStorage.setItem('description', info.Description[0]);
					localStorage.setItem('categoryName', 'live');

				} else if(info.IsVod == '1'){
					localStorage.setItem('title', info.Title[0]);
					localStorage.setItem('description', info.Description[0]);
					localStorage.setItem('categoryName', 'asset');

				} else if(info.IsVod == '0'){
					localStorage.setItem('title', info.Title[0]);
					localStorage.setItem('description', info.Description[0]);
					localStorage.setItem('categoryName', 'live');
				}

				
				if(info.ContentId) {
					localStorage.setItem('contentId', info.ContentId);
				} else {
					localStorage.setItem('contentId', info.ContentID);
				}
				localStorage.setItem('contentUrl', info.ManifestURL);
				if(info.GraphicAssets) {
					localStorage.setItem('graphicAssets', JSON.stringify(info.GraphicAssets));
				}
				localStorage.setItem('contentImage', info.ThumbnailImage);
				localStorage.setItem('contentImagePpro', info.ThumbnailImagePpro);
				localStorage.setItem('contentPosterImagePpro', info.PosterImagePpro);
				localStorage.setItem('contentPosterImage', info.PosterImage);
				localStorage.setItem('duration', info.ContentDuration);
				localStorage.setItem('rating', info.Rating);
				localStorage.setItem('premium', info.IsPremium);
				localStorage.setItem('external', info.IsExternal);
				localStorage.setItem('isP3Content', info.IsP3);
				localStorage.setItem('chunksize', info.Chunksize);
				localStorage.setItem('packaging', info.Packaging);
				localStorage.setItem('codec', info.Codec);
				localStorage.setItem('rateControl', info.RateControl);
				if (info.Profiles) {
					localStorage.setItem('contentProfiles',  JSON.stringify(info.Profiles));
				} else {
					localStorage.setItem('contentProfiles',  'null');
				}
				this.props.history.push('/contentdetails')
				
	   		}
        }
   		
	}

	this.handleChange = (event) => {
        var preassetdatas = [];
        var uniqueArray = [];

        for (var i=0; i<jfinalLists.length; i++) {
          for(var j=0; j<jfinalLists[i].length; j++) {
            for(var k=0; k<jfinalLists[i][j].Contents.length; k++) {
              //console.log(jfinalLists[i][j].Contents[k].IsExternal);
              if( (Object.keys(listOfLive).includes(jfinalLists[i][j].Contents[k].ContentId)) || (Object.keys(listOfLive).includes(jfinalLists[i][j].Contents[k].ContentID)) ) {
                preassetdatas.push( {
                  name: jfinalLists[i][j].Contents[k].Title[0],
                  content: jfinalLists[i][j].Contents[k]
                } );
              } else {
                preassetdatas.push( {
                  name: jfinalLists[i][j].Contents[k].Title,
                  content: jfinalLists[i][j].Contents[k]
                } );
              }
             // preassetdatas.push(jfinalLists[i][j].Contents[k]);
            }
          }
        }
        //console.log(preassetdatas);
        
            // Declare an empty object 
            let uniqueObject = {}; 
              
            // Loop for the array elements 
            for (let i in preassetdatas) { 
                var objTitle = preassetdatas[i]['name']; 
                uniqueObject[objTitle] = preassetdatas[i]; 
            } 
            // Loop to push unique object into array 
            for (i in uniqueObject) { 
                uniqueArray.push(uniqueObject[i]); 
            } 
              

        //console.log(uniqueArray);
        
        if(event.target.value.length > '0') {
          var value = event.target.value.toLowerCase(),
              matches = uniqueArray.filter(function (item) {
				if(item.content.IsVod == "1" || item.content.IsVod == "0") {
					return item.content.Title[0].toLowerCase().includes(value)
				} else {
					return item.name.toLowerCase().includes(value)
				}
              });
              //console.log(matches)
              if(matches.length > '0') {
              	this.setState({
	            	searchData : matches,
	            	noSearchData : 'false'
	            });
              } else {
              	this.setState({
              		searchData : [],
	            	noSearchData : 'true'
	            });
              }
              
            } else {
              this.setState({
                searchData : [],
                noSearchData : 'false'
              });
            }
          
      }

      this.clearSearch = () => { 
      	var serachValue = document.getElementById( 'search_input' ).value;
      	var serachValueSmall = document.getElementById( 'search_input_small' ).value;
			if(serachValue.length > '0') {
				document.getElementById('search_input').value = "";
				if(this.state.searchData.length > '0') {
					this.setState({
		                searchData : [],
		            });
				}
			} else if(serachValueSmall.length > '0') {
				document.getElementById('search_input_small').value = "";
				if(this.state.searchData.length > '0') {
					this.setState({
		                searchData : [],
		            });
				}
			} else {
				if(this.state.searchData.length > '0') {
					this.setState({
		                searchData : [],
		            });
				}
			}
      }

	  this.handleHiddenxsCarousel = () => {
		if(listOfPromotedContent && listOfPromotedContent.length > 0) {
			return {
				padding: '4px 6px 0px'
			 }
		} else {
			return {
				padding: '10px 8px 0px'
			 }
		}
	  }

	  this.handleVisiblexsCarousel = () => {
		if(listOfPromotedContent && listOfPromotedContent.length > 0) {
			return {
				paddingTop: '2px'
			 }
		} else {
			return {
				paddingTop: '8px'
			 }
		}
	  }


	   	return (

	    	<div style={parentdiv}>
			   {/* Tab list and Carousel */}
			   <div className="col-md-12 col-sm-12 col-xs-12 tabNameContainer zero_padding" style={colors}>
			      <div className="col-md-12 col-sm-12 col-xs-12 zero_padding">
			         <div className="col-md-12 zero_padding">
			            <div className="headerforweb hidden-xs" style={this.handleHiddenxsCarousel()}>
			               <div className="col-md-12 zero_padding">
			                  <div className="col-xs-9" style={tabNamepos}>
			                    <div className="dropdown" id="menu_dropdown_large">
									<img src={welcomeuser}/>
									<div className="dropdown-content">
									   <a><span className="cursor_pointer welcome_msg welcome_msg_text" onClick={this.goToLcevcplayer()}>Launch Player</span></a>
									   <a><span className="cursor_pointer welcome_msg welcome_msg_text" onClick={this.goToExperienceplayer()}>Experience Player</span></a>
									   <a><span className="cursor_pointer welcome_msg welcome_msg_text" onClick={this.goToSplitScreenplayer()}>Split screen Player</span></a>
									   <a><span className="cursor_pointer welcome_msg welcome_msg_text" onClick={this.goToAccount()}>My Account</span></a>
									   <a><span className="cursor_pointer welcome_msg welcome_msg_text" onClick={this.goToAbout()}>About</span></a>
									   <a><span className="cursor_pointer welcome_msg_text" data-toggle="modal" data-target="#logoutModal">Logout</span></a>
									</div>
								</div>
			                     
			                    <div className="nav nav-pills tabNameulNav" id="myTab" style={tabNameul}>
			                    <Slider {...tabSlideConfig} className="lTabSlider">
			                    	{newContentCategory.map((contentCategory,i) => 
				                    	<div key = {i} className="nav_ul_li text_align_center text_ellipsis"><a data-toggle="tab" href={ '#' + i} onClick={this.setActive(i,contentCategory)}>{contentCategory.title}</a></div>
				                    )}
				                    
				                </Slider>
			                    </div>
			                  </div>
			                  <div className="col-xs-3 welcome_msg_container">

			                  	<div className="col-xs-8 zero_padding" style={{textAlign: 'start',top: '8px'}} >
							        <input id="search_input" autoComplete="off" className="search_input" style={{width: '95%'}} placeholder="Search" type="text" onChange={(e) => this.handleChange(e)} />
							        {
							          (this.state.searchData.length != '0') ? 
							          (
							            <div className="search_container">
							              {this.state.searchData.map((contents,id) =>
							              	(contents.content.GraphicAssets !== undefined) ? 
							              	(
							              		<div key = {id} id={id} className="search_datas col-xs-12">
								                  {
								                  	(isVNovaUser == '1') ?
								                  	(<span className="cursor_pointer" id="search_data_nograp_vuser" onClick={this.goToContentDetails(contents.content)}>
									                    <img className="search_datas_img col-xs-5 zero_padding" src={(this.state.imageBaseURI + contents.content.GraphicAssets.Png.Web.Thumbnail+ '?' + imageCacheValue)} onError={(e) => {e.persist();this.onListError(e,contents.content.ContentID)}} />
									                    &nbsp;
									                    {
															( ( (Object.keys(listOfLive).includes(contents.content.ContentId)) || (Object.keys(listOfLive).includes(contents.content.ContentID)) ) && ( (contents.content.IsExternal == '0') || (contents.content.IsExternal == null)) ) ?
															(
																<span className="col-xs-7 zero_padding search_datas_title wrapword">{contents.content.Title[0]}&nbsp;<sup className="superscript_live_tag">LIVE</sup></span>
															):
															(
																<span className="col-xs-7 zero_padding search_datas_title wrapword">{contents.content.Title}</span>
															)
														}
									                  </span>) :
													(<span className="cursor_pointer" id="search_data_nograp_nvuser" onClick={this.goToContentDetails(contents.content)}>
									                    {
															( ( (Object.keys(listOfLive).includes(contents.content.ContentId)) || (Object.keys(listOfLive).includes(contents.content.ContentID)) ) && ( (contents.content.IsExternal == '0') || (contents.content.IsExternal == null)) ) ?
															(
																<span className="col-xs-12 zero_padding wrapword">{contents.content.Title[0]}&nbsp;<sup className="superscript_live_tag">LIVE</sup></span>
															):
															(
																<span className="col-xs-12 zero_padding wrapword">{contents.content.Title}</span>
															)
														}
									                </span>)
								                  }
								                </div>
							              	) : 
							              	(
							              		<div key = {id} id={id} className="search_datas col-xs-12">
								                	{
								                  	(isVNovaUser == '1') ?
								                  		(<span className="cursor_pointer" id="search_data_grap_vuser" onClick={this.goToContentDetails(contents.content)}>
									                    <img className="search_datas_img col-xs-5 zero_padding" src={(this.state.imageBaseURI + contents.content.ThumbnailImage+ '?' + imageCacheValue)} onError={(e) => {e.persist();this.onListError(e,contents.content.ContentID)}} />
									                    &nbsp;
									                    {
															( ( (Object.keys(listOfLive).includes(contents.content.ContentId)) || (Object.keys(listOfLive).includes(contents.content.ContentID)) ) && ( (contents.content.IsExternal == '0') || (contents.content.IsExternal == null)) ) ?
															(
																<span className="col-xs-7 zero_padding search_datas_title wrapword">{contents.content.Title[0]}&nbsp;<sup className="superscript_live_tag">LIVE</sup></span>
															):
															(
																<span className="col-xs-7 zero_padding search_datas_title wrapword">{contents.content.Title}</span>
															)
														}
									                  </span>) :
									                  (<span className="cursor_pointer" id="search_data_grap_nvuser" onClick={this.goToContentDetails(contents.content)}>
									                    {
															( ( (Object.keys(listOfLive).includes(contents.content.ContentId)) || (Object.keys(listOfLive).includes(contents.content.ContentID)) ) && ( (contents.content.IsExternal == '0') || (contents.content.IsExternal == null)) ) ?
															(
																<span className="col-xs-12 zero_padding wrapword">{contents.content.Title[0]}&nbsp;<sup className="superscript_live_tag">LIVE</sup></span>
															):
															(
																<span className="col-xs-12 zero_padding wrapword">{contents.content.Title}</span>
															)
														}
									                  </span>)
								                  	}
								                </div> 
							              	)
							              )}
							            </div>
							          ) 
							          :
							          (<span></span>) 
							        }
							        {
							          (this.state.noSearchData == 'true') ? 
							          (<div className="search_container no_search_container">
							          	<span id="no_search_text_large" className="no_search_text">No Result found</span>
							          </div>)
							          :
							          (<span></span>)
							      	}
							      </div>

			                     <div className="col-xs-4 zero_padding">
								 	<img src={logo} alt="LOGO" className="tab_logo" onClick={this.goToHomeWebsite()} />
								 	{
								      (isStaging == 'true') ? (
								        <div style={{marginTop: '-5px'}}>
								          <span className="staging_platform_landing_lg">STAGING</span>
								        </div>
								      ) : (
								        <span></span>
								      )
								    }
			                     </div>

			                  </div>
			               </div>
			            </div>
			            <div className="headerforweb visible-xs" style={this.handleVisiblexsCarousel()}>
			               <div className="col-md-12 padding_left_right_5">
			                  
			                  	<div className="text_align_initial">
					              <div className="dropdown" id="menu_dropdown_small">
					                  <img src={welcomeuser}/>
					                  <div className="dropdown-content">
					                    <a><span className="cursor_pointer welcome_msg welcome_msg_text" onClick={this.goToLcevcplayer()}>Launch Player</span></a>
										<a><span className="cursor_pointer welcome_msg welcome_msg_text" onClick={this.goToExperienceplayer()}>Experience Player</span></a>
									   	<a><span className="cursor_pointer welcome_msg welcome_msg_text" onClick={this.goToSplitScreenplayer()}>Split screen Player</span></a>
					                    <a><span className="cursor_pointer welcome_msg welcome_msg_text" onClick={this.goToAccount()}>My Account</span></a>
					                    <a><span className="cursor_pointer welcome_msg welcome_msg_text" onClick={this.goToAbout()}>About</span></a>
					                    <a><span className="cursor_pointer welcome_msg_text" data-toggle="modal" data-target="#logoutModal">Logout</span></a>
					                  </div>
					                </div>
					              
					              <span className="welcome_msg_detail_span">
					                
					                <div className="dropdown" id="serach_dropdown">
						                <input id="search_input_small" autoComplete="off" className="search_input" style={{width: '95%'}} placeholder="Search" type="text" onChange={(e) => this.handleChange(e)} />
								        {
								          (this.state.searchData.length != '0') ? 
								          (
								            <div className="search_container">
								              {this.state.searchData.map((contents,id) =>
								              	(contents.content.GraphicAssets !== undefined) ? 
								              	(
								              		<div key = {id} id={id} className="search_datas col-xs-12">
									                	{
									                  	(isVNovaUser == '1') ?
									                  	(<span className="cursor_pointer" id="search_data_nograp_vuser_small" onClick={this.goToContentDetails(contents.content)}>
										                    <img className="search_datas_img col-xs-5 zero_padding" src={(this.state.imageBaseURI + contents.content.GraphicAssets.Png.Web.Thumbnail+ '?' + imageCacheValue)} onError={(e) => {e.persist();this.onListError(e,contents.content.ContentID)}} />
										                    &nbsp;
										                    {
																( ( (Object.keys(listOfLive).includes(contents.content.ContentId)) || (Object.keys(listOfLive).includes(contents.content.ContentID)) ) && ( (contents.content.IsExternal == '0') || (contents.content.IsExternal == null)) ) ?
																(
																	<span className="col-xs-7 zero_padding search_datas_title wrapword">{contents.content.Title[0]}&nbsp;<sup className="superscript_live_tag">LIVE</sup></span>
																):
																(
																	<span className="col-xs-7 zero_padding search_datas_title wrapword">{contents.content.Title}</span>
																)
															}
										                  </span>) : 
									                  	(<span className="cursor_pointer" id="search_data_nograp_nvuser_small" onClick={this.goToContentDetails(contents.content)}>
										                    {
																( ( (Object.keys(listOfLive).includes(contents.content.ContentId)) || (Object.keys(listOfLive).includes(contents.content.ContentID)) ) && ( (contents.content.IsExternal == '0') || (contents.content.IsExternal == null)) ) ?
																(
																	<span className="col-xs-12 zero_padding wrapword">{contents.content.Title[0]}&nbsp;<sup className="superscript_live_tag">LIVE</sup></span>
																):
																(
																	<span className="col-xs-12 zero_padding wrapword">{contents.content.Title}</span>
																)
															}
										                  </span>)
									                  	}
									                </div> 
								              	) : 
								              	(
								              		<div key = {id} id={id} className="search_datas col-xs-12">
									                	{
									                  	(isVNovaUser == '1') ?
									                  	(<span className="cursor_pointer" id="search_data_grap_vuser_small" onClick={this.goToContentDetails(contents.content)}>
									                    <img className="search_datas_img col-xs-5 zero_padding" src={(this.state.imageBaseURI + contents.content.ThumbnailImage+ '?' + imageCacheValue)} onError={(e) => {e.persist();this.onListError(e,contents.content.ContentID)}} />
									                    &nbsp;
									                    {
															( ( (Object.keys(listOfLive).includes(contents.content.ContentId)) || (Object.keys(listOfLive).includes(contents.content.ContentID)) ) && ( (contents.content.IsExternal == '0') || (contents.content.IsExternal == null)) ) ?
															(
																<span className="col-xs-7 zero_padding search_datas_title wrapword">{contents.content.Title[0]}&nbsp;<sup className="superscript_live_tag">LIVE</sup></span>
															):
															(
																<span className="col-xs-7 zero_padding search_datas_title wrapword">{contents.content.Title}</span>
															)
														}
									                  </span>) : 
									                  (<span className="cursor_pointer" id="search_data_grap_nvuser_small" onClick={this.goToContentDetails(contents.content)}>
									                    {
															( ( (Object.keys(listOfLive).includes(contents.content.ContentId)) || (Object.keys(listOfLive).includes(contents.content.ContentID)) ) && ( (contents.content.IsExternal == '0') || (contents.content.IsExternal == null)) ) ?
															(
																<span className="col-xs-12 zero_padding wrapword">{contents.content.Title[0]}&nbsp;<sup className="superscript_live_tag">LIVE</sup></span>
															):
															(
																<span className="col-xs-12 zero_padding wrapword">{contents.content.Title}</span>
															)
														}
									                  </span>)
									                  	}
									                </div> 
								              	)
								              )}
								            </div>
								          ) 
								          :
								          (<span></span>) 
								        }
								        {
								          (this.state.noSearchData == 'true') ? 
								          (<div className="search_container no_search_container">
								          	<span id="no_search_text_small" className="no_search_text">No Result found</span>
								          </div>)
								          :
								          (<span></span>)
								      	}
					                </div>

					                <img src={logo} alt="LOGO" className="assetdetail_logo assetdetail_logo_landing" onClick={this.goToHomeWebsite()} />
					              {
							          (isStaging == 'true') ? (
							              <span className="staging_platform_landing_xs">STAGING</span>
							          ) : (
							            <span></span>
							          )
							        }

					              </span>
					            </div>

			                  <div className="col-xs-12 padding_left_right_zero text_align_initial">

			                  	<div className="nav nav-pills" id="myTab" style={tabNameulsmall}>
			                    <Slider {...tabSlideConfig} className="STabSlider">
			                    	{newContentCategory.map((contentCategory,i) => 
				                    	<div key = {i} className="nav_ul_li text_align_center text_ellipsis"><a data-toggle="tab" href={ '#' + i} onClick={this.setActive(i,contentCategory)}>{contentCategory.title}</a></div>
				                    )}
				                </Slider>
			                    </div>

			                  </div>
			               </div>
			            </div>
			            {/* Carousel */}
			            <Slider {...promSlideConfig} className="promoContentSlide">
			               {promotedContentArray.map((promotedContent,i) => 
			               	<div key = {i} className="outline_none">
			               	{
			               		(promotedContent != null) ? 
			               		(
			               		<div key = {i} className="outline_none">
			                  
			               		{
									(this.state.imagetypeforslider == 'p2')?( 
										
										<div>
						                    {
				                  				(listOfPromotedContent) ? (
				                  					<span>
					                  					{listOfPromotedContent.map((list,i) => 
				               								<div key = {i} className="outline_none">
				               									{
				               										( (list.Contentid == promotedContent.ContentId) || (list.Contentid == promotedContent.ContentID) )?
				               										(
				               										<div className="caro_placeholder" id="caro_placeholder" ref={(el) => {
													                    if (el) {
													                     el.style.setProperty('background', "linear-gradient(rgba(16, 24, 62,.9), rgba(16, 24, 62,.8)),url(" + this.state.imageBaseURI +list.Weburlposter + ")");
													                     }
													                    }}>
													                    <div onClick={this.goToContentDetails(promotedContent)} className="cursor_pointer caro_sample">
												                  			<perseus-img src={(this.state.imageBaseURI + promotedContent.ThumbnailImagePpro) } onError={(e) => {e.target.src = posterReplacement }}> </perseus-img>
												                  		</div>
													                </div>

				               										): (
				               										<span></span>
				               										)
				               									}
				               								</div>
				               							)}
			               							</span>
				                  				) : (
				                  					<span>
				                  						<div className="caro_placeholder" id="caro_placeholder" ref={(el) => {
										                    if (el) {
										                     el.style.setProperty('background', "linear-gradient(rgba(16, 24, 62,.9), rgba(16, 24, 62,.8)),url(" + this.state.imageBaseURI +promotedContent.ThumbnailImagePpro + ")");
										                     }
										                    }}>
										                    <div onClick={this.goToContentDetails(promotedContent)} className="cursor_pointer caro_sample">
									                  			<perseus-img src={(this.state.imageBaseURI + promotedContent.ThumbnailImagePpro) } onError={(e) => {e.target.src = posterReplacement }}> </perseus-img>
									                  		</div>
										                </div>
				                  					</span>
				                  				)
				                  			}
							            </div>
										
				                  	) : 
				                  	( 

				                  		<div>
				                  			{
				                  				(listOfPromotedContent) ? (
				                  					<span>
					                  					{listOfPromotedContent.map((list,i) => 
				               								<div key = {i} className="outline_none">
				               									{
				               										( (list.Contentid == promotedContent.ContentId) || (list.Contentid == promotedContent.ContentID) )?
				               										(
				               										<div className="caro_placeholder" id="caro_placeholder" ref={(el) => {
													                    if (el) {
													                     el.style.setProperty('background', "linear-gradient(rgba(16, 24, 62,.9), rgba(16, 24, 62,.8)),url(" + this.state.imageBaseURI +list.Weburlposter+ '?' + imageCacheValue + ")");
													                     }
													                    }}>
													                    <img onClick={this.goToContentDetails(promotedContent)} className="caro_sample" id="caro_sample" src={this.state.imageBaseURI +list.Weburlposter+ '?' + imageCacheValue } onError={(e) => {e.target.src = posterReplacement }} />
													                </div>

				               										): (
				               										<span></span>
				               										)
				               									}
				               								</div>
				               							)}
			               							</span>
				                  				) : (
				                  					<span>
				                  						<div className="caro_placeholder" id="caro_placeholder" ref={(el) => {
										                    if (el) {
										                     el.style.setProperty('background', "linear-gradient(rgba(16, 24, 62,.9), rgba(16, 24, 62,.8)),url(" + this.state.imageBaseURI +promotedContent.ThumbnailImage+ '?' + imageCacheValue + ")");
										                     }
										                    }}>
										                    <img onClick={this.goToContentDetails(promotedContent)} className="caro_sample" id="caro_sample" src={this.state.imageBaseURI +promotedContent.ThumbnailImage+ '?' + imageCacheValue } onError={(e) => {e.target.src = posterReplacement }} />
										                </div>
				                  					</span>
				                  				)
				                  			}
						                    
							            </div>
				                  	) 
								}

			               </div>
			               		) : 
			               	(<div className="caro_placeholder"></div>)
			               	}
			               	</div>
			               
			               )}
			            </Slider>

			            <div className="headerforwebbottom"></div>

			         </div>
			      </div>
			      {/* End of Carousel */}
			   </div>
			   {/* End of Tab list and Carousel */}

			   {/*Main Content*/}
			   <div className="content_container col-md-12 col-sm-12 col-xs-12 zero_padding" style={colors}>
			      {/* Content Categories */}
			      <div className="headerforwebbottom"></div>
			     
			      
			      	{
				        (jfinalLists)? 
				        (
				        <div className="tab-content">
				        	{newContentCategory.map((contentCategory,id) =>
				        		<div key = {id} id={id} className="tab-pane contentCategories_container" style={{ marginTop: promotedContentArray.length > 0 ? '10px': '75px'}}>
					               {
								        (jfinalLists[id].length != '0')? 
								        (
							               <div className="col-md-12 col-sm-12 col-xs-12">
								            {jfinalLists[id].map((minfo,i) => 
								            	<div key = {i}>
								            	{
								                  (minfo.Contents.length != '0')?(
								            <div key = {i} className="bouquet_title">

								            	{ 
										          (contentCategory.vertical == '1')?( 
										            <b className="padding_left_10">{minfo.Name}</b> 
										          ) : ( <span></span> ) 
										        }
								            	 
								               

								            	{
							        			(contentCategory.vertical == '1')?

							        			(
							        				<Slider className="padding_left_10 padding_top_10 bouqetContentSlide" {...slideConfig}>
								                  {minfo.Contents.map((info,i) => 
								                  <div key = {i} className="placeholder" id="placeholder">
								                     
								                    {
									                  (this.state.imagetypeforlist == 'p2')?( 

									                  	<div className="PproPlaceholder">
									                  	
										                    <div onClick={this.goToContentDetails(info)} className="assetImg cursor_pointer">
										                    	<perseus-img src={(this.state.imageBaseURI + info.ThumbnailImagePpro) } onError={(e) => {e.target.src = replacement }}> </perseus-img>
										                    	{
													                        (this.state.overlayTextEnabled == '1')? (
														                        <span>
														                        {
														                        	( (Object.keys(listOfLive).includes(info.ContentId)) || (Object.keys(listOfLive).includes(info.ContentID)) ) ?
														                        	(
														                        	<div className="list_overlay" style={assetOverlaybg}>
															                           <div className="text wrapword" style={assetOverlaytext}>{info.Title[0]}</div>
															                        </div>
														                        	):
														                        	(
														                        	<div className="list_overlay" style={assetOverlaybg}>
															                           <div className="text wrapword" style={assetOverlaytext}>{info.Title}</div>
															                        </div>
														                        	)
														                        }
														                        </span>
													                        ) : (
													                        <span></span>
													                        )
												                        }
										                    </div>
										                </div>
									                  ) : 
									                  ( 
									                   <div>
										                	{
										                		(info.GraphicAssets !== undefined)?
										                		(
										                			<div onClick={this.goToContentDetails(info)}>
												                    	<img id="assetImg" className="assetImg" src={this.state.imageBaseURI + info.GraphicAssets.Png.Web.Thumbnail+ '?' + imageCacheValue } onError={(e) => {e.persist();this.onListError(e,info.ContentID)}} />
												                        {
													                        (this.state.overlayTextEnabled == '1')? (
														                        <span>
														                        {
														                        	( (Object.keys(listOfLive).includes(info.ContentId)) || (Object.keys(listOfLive).includes(info.ContentID)) ) ?
														                        	(
														                        	<div className="list_overlay" style={assetOverlaybg}>
															                           <div className="text wrapword" style={assetOverlaytext}>{info.Title[0]}</div>
															                        </div>
														                        	):
														                        	(
														                        	<div className="list_overlay" style={assetOverlaybg}>
															                           <div className="text wrapword" style={assetOverlaytext}>{info.Title}</div>
															                        </div>
														                        	)
														                        }
														                        </span>
													                        ) : (
													                        <span></span>
													                        )
												                        }
												                    </div>
										                		) 
										                		:
										                		(
										                			<div onClick={this.goToContentDetails(info)}>
												                    	<img id="assetImg" className="assetImg" src={this.state.imageBaseURI + info.ThumbnailImage+ '?' + imageCacheValue } onError={(e) => {e.persist();this.onListError(e,info.ContentID)}} />
												                        {
													                        (this.state.overlayTextEnabled == '1')? (
														                        <span>
														                        {
														                        	( (Object.keys(listOfLive).includes(info.ContentId)) || (Object.keys(listOfLive).includes(info.ContentID)) ) ?
														                        	(
														                        	<div className="list_overlay" style={assetOverlaybg}>
															                           <div className="text wrapword" style={assetOverlaytext}>{info.Title[0]}</div>
															                        </div>
														                        	):
														                        	(
														                        	<div className="list_overlay" style={assetOverlaybg}>
															                           <div className="text wrapword" style={assetOverlaytext}>{info.Title}</div>
															                        </div>
														                        	)
														                        }
														                        </span>
													                        ) : (
													                        <span></span>
													                        )
												                        }
												                    </div>
										                		) 
										              		}
										                  	
										                  
										                </div>
									                  ) 
									                }

								                     <div> 
								                        { 
								                        (info.IsPremium == '1')?( 
								                        <img className="premium" src={premium} alt="Premium" />
								                        ) : ( <span></span> ) 
								                        }
								                     </div>
								                     <div> 
														{minfo.contentType.map((infoType,i) => 
															<div key = {i}>

																{ 
																(  ( (info.ContentId == infoType.contentId) || (info.ContentID == infoType.contentId)  ) && (infoType.type == 'LIVE' || (info.IsVod && info.IsVod != '1') ) )?( 
																<img className="livebtn_content" src={liveBtn} alt="Live" />
																) : ( <span></span> ) 
																}

															</div>
														)}
							                         </div>

								                  </div>
								                  )}
								               </Slider>
							        			)

							        			 :

							        			(
							        			
						        				<div className="col-md-12 col-sm-12 col-xs-12 padding_left_right_zero">
						        				{/*NON V-NOVA USER*/}
													{minfo.Contents.map((info,i) => 
													<div key = {i} className="col-md-12 col-sm-12 col-xs-12 nvu_placeholder" id="placeholder">
													 
													 	<span onClick={this.goToContentDetails(info)}>
															{
																( ( (Object.keys(listOfLive).includes(info.ContentId)) || (Object.keys(listOfLive).includes(info.ContentID)) ) || ( (Object.keys(listOfDemoCntLive).includes(info.ContentId)) || (Object.keys(listOfDemoCntLive).includes(info.ContentID)) ) ) ?
																(
															       <div className="simple_vod_live_title">{info.Title[0]}<img className="livebtn_content" src={liveBtn} alt="Live" /></div>
																):
																(
															       <div className="simple_vod_live_title">{info.Title}</div>
																)
															}
														</span>

													</div>
													)}
												{/*END - NON V-NOVA USER*/}
												</div>

							        			)

							        			}


								            </div>
								            ) :(<span id={id} className="col-xs-12 no_content_text">No content is available in this category</span>)
									        }
									            </div>
								            	)}
								            </div>
								            ):(<span id={id} className="col-xs-12 no_content_text">No content is available in this category</span>)
									    	}
							            </div>
							            )}
							       

				        </div>
				         ):(<span></span>)
			         }

			      {/* End of Content Categories */}
		      	 

			   </div>
			   {/*End of Main Content*/}


			   {/*Welcome Popup Modal Window*/}
		        <div className="modal fade" id="welcomePopupModal" role="dialog">
		          <div className="modal-dialog welcomePopup_modal_dialog">
		            <div className="modal-content welcomePopup_modal_content">
		              
		              <div className="modal-body">
		                <div><b>Welcome to the V-Nova Website</b></div><br/>
		                <div>
		                  This website shows a variety of example MPEG-5 LCEVC-enhanced H.264/AVC video streams for both Live and VOD content. Watch the streams to see the high quality achievable at low bitrates. Users of the V-Nova Platform can also use the website to play back their own content by logging in with those credentials.
		                </div><br/>
		                <div>
		                  <input className="checkbox_input position_absolute" type="checkbox" name="terms" id="hidepopup" onClick={this.toggleWelcomepopup()} />&emsp;&nbsp;&nbsp;&nbsp;<span>Do Not Show Again</span>
		                </div>
		              </div>

		              <div className="welcome_popup_btn">
		                <span className="cursor_pointer text_white_color" data-dismiss="modal">Ok</span>&emsp;&emsp;&nbsp;
		              </div>
		             
		            </div>
		            
		          </div>
		        </div>
		      {/*End of Welcome Popup Modal Window*/}


			{/*Modal Window*/}
			  <div className="modal fade" id="logoutModal" role="dialog">
			    <div className="modal-dialog logout-modal-dialog">
			      <div className="modal-content">
			        
			        <div className="modal-body">
			          	<div>Are you sure, you want to logout?</div>
			        </div>

			        <div className="logoutModalBtn">
			        	<span className="cursor_pointer logoutModalBtn_cancel" data-dismiss="modal">Cancel</span>&emsp;&emsp;&nbsp;
			        	<span className="cursor_pointer logoutModalBtn_ok" data-dismiss="modal" onClick={this.logout()}>Logout</span>
			        </div>
			       
			      </div>
			      
			    </div>
			  </div>
			{/*End of Modal Window*/}

			   <footer className='col-xs-12'>
			    	<div className='footer_version' style={colors}>Version : {version.Version}</div>
			   </footer>
			</div>

	    );
	}
}

export default Landing;